export default {
  salesCenter: {
    caseLabel: 'Case',
    viewCount: 'Views',
    viewRule: 'View Rules',
    collectCount: 'Favorites',
    outboundCaller: 'Outbound Caller',
    outboundRecordsQueryTime: 'Query Time:',
    outboundRecordsCallDuration: 'Call Duration:',
    outboundRecordsPhoneStatus: 'Phone Status',
    callTypeOutbound: 'Outbound',
    callType: 'Call Type',
    activityId: 'Activity ID',
    aboutToRecycle: 'About to be Recycled',
    above6000: 'Above 6,000',
    accountActivateDate: 'Account Activation Date',
    accountActivateDateLabel: 'Account Activation Date:',
    accountActivateTime: 'Account Activation Time',
    outCallAgentLoginMode: 'Agent Login',
    accountPhoneRebind: 'Phone Number Rebinding',
    accountStatus: 'Account Status',
    accountStatusLabel: 'Account Status:',
    accountColumn: 'Account',
    emailColumn: 'Email',
    emailFormPlaceholder: 'Enter email',
    emailFormatInvalid: 'Please enter a valid email address',
    backActivityList: 'Back to Activity List',
    accountValidPeriod: 'Account Validity Period',
    activate: 'Activated',
    activity: 'Activity',
    activityCreateFail: 'Failed to create activity',
    activityCreateSuccess: 'Activity created successfully',
    createActivityButton: 'Create Activity',
    activityStatusNotStarted: 'Not Started',
    activityStatusInProgress: 'In Progress',
    activityStatusEnded: 'Ended',
    inviteRewardPeopleSuffix: 'people rewarded',
    inStoreRewardPeopleSuffix: 'people rewarded',
    activityDeleteFail: 'Failed to delete activity',
    activityDeleteSuccess: 'Activity deleted successfully',
    activityEditFail: 'Failed to edit activity',
    activityEditSuccess: 'Activity updated successfully',
    activityName: 'Activity Name',
    activityPauseFail: 'Failed to pause activity',
    activityPauseSuccess: 'Activity paused successfully',
    activityPublishFail: 'Failed to publish activity',
    activityPublishSuccess: 'Activity published successfully',
    activityStartFail: 'Failed to start activity',
    activityStartSuccess: 'Activity started successfully',
    activityTemplateTitle: 'Marketing Activity Templates',
    activityGalleryAddNewTemplate: 'Add New Activity Template',
    actualReturnAmount: 'Total Returned Amount (Counter)',
    actualVisitTime: 'Actual Visit Time:',
    actualVisitTip: 'The actual time the customer visited the Learning Center',
    adapAccountLabel: 'Adaptive Learning Account:',
    adaptiveAccountLabel: 'Adaptive Learning Account:',
    pleaseSelectAdaptiveAccount: 'Please select Adaptive Learning Account',
    add: 'Add',
    addCounter: 'Add Counter',
    addExamInfo: 'Add Exam Information',
    addFollowRecord: 'Add Follow-up Record',
    addLead: 'Add Lead',
    addReport: 'Add Report',
    addScoreFail: 'Failed to add score',
    addSingleImage: 'Add Image',
    addSubTag: 'Add Sub-tag',
    addSuccess: 'Added successfully',
    addTagType: 'Add Tag Type',
    addUserProfile: 'Add User Profile',
    addVideo: 'Add Video',
    addressTooShort: 'Address is too brief. Please provide a detailed address',
    adjustTable: 'Adjust Table View',
    admissionCannotExceedFinalScore: 'Admission score cannot exceed final score',
    admissionScoreCannotExceedSubjectTotal: 'Admission score cannot exceed subject total score',
    admissionScoreCannotExceedTotal: 'Admission score cannot exceed total score',
    admissionScoreFormatError: 'Invalid admission score format',
    admissionScoreLabel: 'Admission Score',
    admissionStageGrade: 'Admission Grade Level',
    admissionStageCannotExceedCurrent: 'Admission grade level cannot exceed current grade level',
    agent: 'Associated Master Franchisee',
    agentId: 'Master Franchisee ID',
    agentLabel: 'Master Franchisee',
    agentName: 'Master Franchisee Name',
    agreeTransfer: 'Approve Transfer',
    all: 'All',
    allLeads: 'All Leads',
    allocated: 'Allocated',
    allocation: 'Allocation',
    already: 'Subscribed',
    alreadyExpired: 'Expired',
    analystLabel: 'Analyst:',
    applySuccess: 'Application submitted successfully',
    applyTimeLabel: 'Application Time:',
    applyTransfer: 'Apply for Transfer',
    appointmentTimeAfterNow: 'Selected time must be later than the current time',
    approvalFailed: 'Approval failed',
    approvalSuccess: 'Approval successful',
    assignAnalyst: 'Assign Analyst',
    assignSuccess: 'Assigned successfully',
    assignTo: 'Assign to:',
    audit: 'Reviewer',
    auditBy: 'Confirmed by',
    auditRejectReason: 'Rejection Reason',
    auditRejectTip: 'Your submitted school "{name}" was not approved. Reason: "{remark}". Please revise and resubmit',
    auditRemark: 'Confirmation Remark',
    auditStatus: 'Review Status',
    auditTime: 'Confirmation Time',
    availablePrototypeCount: 'Available Demo Device Count',
    back: 'Back',
    basicInfo: 'Basic Information',
    batchAllocation: 'Batch Allocation',
    batchAllocationFailed: 'Batch allocation failed',
    batchAllocationSuccess: 'Batch allocation successful',
    batchAssignAnalyst: 'Batch Assign Analyst',
    batchAssignFollowPerson: 'Batch Assign Follow-up Owner',
    batchAssignServicePerson: 'Batch Assign Service Owner',
    batchAllocateFollower: 'Batch Assign Follow-up Owner',
    batchClaim: 'Batch Claim',
    batchCollection: 'Batch Claim',
    batchCollectionFailed: 'Batch claim failed',
    batchCollectionSuccess: 'Batch claim successful',
    batchExport: 'Batch Export',
    batchImport: 'Batch Import',
    batchImportBusy: 'The system is busy with batch imports. Please try again in 10 minutes',
    batchImportLead: 'Batch Import Leads',
    batchOperation: 'Batch Operation:',
    batchRecall: 'Batch Recall',
    batchRecoverSuccess: 'Batch recall successful',
    batchRelease: 'Batch Release',
    batchReleaseSuccess: 'Batch release successful',
    batchRestore: 'Batch Restore',
    batchRestoreSuccess: 'Batch restore successful',
    batchSaveTip: ', up to 5 images per save',
    batchUploadImages: 'Batch Upload Images',
    batchUploadTip: 'Note: When uploading multiple images, names will be auto-numbered (e.g., "Daily Image 01"). You can edit them later in the gallery',
    bayear: 'Grade 8',
    below2000: 'Below 2,000',
    bestSize: 'Recommended size: 1080×1920',
    between2000and4000: '2,000–4,000',
    between4000and6000: '4,000–6,000',
    bianji: 'Last Edited By',
    bindFailed: 'Binding failed',
    bindPhoneTip: 'This account is not linked to a phone number and cannot switch Learning Center. Please bind a phone number first',
    bindPhoneTitle: 'Bind Phone Number',
    bindSuccess: 'Binding successful',
    birthDate: 'Date of Birth:',
    birthDateLabel: 'Date of Birth',
        birthDateFormLabel: 'Date of Birth:',
    birthDateLabelShort: 'Date of Birth:',
    briefIntroLength50_500: 'Introduction must be 50–500 characters',
    businessStatus: 'Business Status',
    buttonPicLabel: 'Button Image:',
    campus: 'Learning Center',
    cancel: 'Cancel',
    cancelCreateDone: 'Creation cancelled',
    cancelDeleteDone: 'Deletion cancelled',
    cancelFollow: 'Cancel Follow-up',
    cancelFollowReasonTip: 'Please provide a reason for canceling follow-up',
    cancelFollowSuccess: 'Follow-up canceled successfully',
    cancelPauseDone: 'Pause cancelled',
    cancelPublish: 'Cancel Publishing',
    cancelPublishDone: 'Publishing cancelled',
    cancelPublishFailed: 'Failed to cancel publishing',
    cancelReason: 'Cancel Reason:',
    cancelReasonLabel: 'Cancel Reason:',
    cancelReportConfirmText: 'Are you sure you want to cancel the report request? Once canceled, this device cannot be activated across regions',
    cancelReportConfirmTitle: 'Cancel Report Request',
    cancelReportFail: 'Cancellation failed',
    cancelReportSuccess: 'Report request canceled successfully',
    cancelStartDone: 'Start cancelled',
    cancelSuccess: 'Cancelled successfully',
    cannotChangeSubmitted: 'This information has been submitted for review and cannot be modified',
    cannotWithdrawApproved: 'The student enrollment has been approved and cannot be withdrawn',
    caseTitleLength: 'Case Title: 5–20 characters',
    catalogCategory: 'Category',
    catalogNameMax10: 'Category name must be within 10 characters',
    categoryNameRequired: 'Category name is required',
    changeSuccess: 'Updated successfully',
    channel: 'Channel',
    channelSource: 'Channel Source',
    channelSourceStats: 'Channel Source Statistics',
    cihour: 'First Vote Time',
    citeExistingLead: 'Reference Existing Lead:',
    citeLeadTip: 'You can reference leads created under "Potential Customers" to quickly complete the profile',
    citeLeadTipHtml: 'You can reference leads created under <span style="font-weight: 600;">"Potential Customers"</span> to quickly complete the profile',
    claimStudent: 'Claim Student',
    claimStudentValidityTip: 'Claimed students are valid for 7 days. Please follow up promptly',
    claimSuccess: 'Claim successful',
    clickToViewVideo: 'Click to view video',
    clickUpload: 'Click to upload',
    closeFailed: 'Close failed',
    closeSuccess: 'Closed successfully',
    closeTitle: 'Close',
    code: 'Code',
    collapse: 'Collapse',
    compliant: 'Compliant',
    confirm: 'Confirm',
    confirmAcceptTransfer: 'Confirm accepting transferred student?',
    confirmCancelPublishMaterial: 'Are you sure you want to cancel publishing this material?',
    confirmDeleteImage: 'Are you sure you want to delete this image?',
    confirmDeleteMarker: 'Are you sure you want to delete this marker?',
    confirmDeleteMaterial: 'Are you sure you want to delete this material? This action cannot be undone',
    confirmDeleteTagType: 'Confirm deletion of tag type "{name}"?',
    confirmDeleteTemplate: 'Confirm deletion of template',
    confirmOffShelfImage: 'Are you sure you want to remove this image from listing?',
    confirmOffShelfTemplate: 'Confirm removing template from listing',
    confirmPublishImage: 'Are you sure you want to publish this image?',
    confirmPublishMaterial: 'Are you sure you want to publish this material?',
    confirmPublishTemplate: 'Confirm publishing template',
    confirmReceiveCustomers: 'Are you sure you want to claim these {n} customers?',
    confirmRejectTransfer: 'Are you sure you want to reject the transfer of the new student?',
    confirmRestoreCluesTip: 'Are you sure you want to restore these {n} leads?',
    confirmRevokeApply: 'Are you sure you want to revoke the application?',
    confirmSubmitAudit: 'Are you sure you want to submit for review?',
    confirmUnmarkPrototype: 'Are you sure you want to remove the Demo Device label?',
    confirmUpdate: 'Confirm update',
    confirmUpdateTip: 'Are you sure you want to update?',
    considerAgain: 'Think it over',
    consultation: 'Consultation',
    contactInfo: 'Contact Information',
    converted: 'Converted',
    coordsParentAgentId: 'Parent Master Franchisee ID (Coordinates)',
    coordsPassed: 'Coordinates Verified',
    coordsProvinceCity: 'Coordinates (State/City/District)',
    counterCloseConfirm: 'Closing the counter cannot be undone.<br />Are you sure you want to proceed?',
    counterInfoExport: 'Counter Information Export',
    course: 'Course',
    courseName: 'Course Name',
    textbookVersion: 'Textbook Version',
    orderRecords: 'Order Records',
    invitationRecords: 'Invitation Records',
    learningReport: 'Learning Report',
    sailingTrialClass: 'Intro Trial Class',
    createBy: 'Created By',
    createFail: 'Creation failed',
    createMaterial: 'Create Material',
    createSuccess: 'Created successfully',
    crossAreaTypeFail: 'Failed to retrieve cross-region type and reporting Master Franchisee',
    crossRegionNotReported: 'Cross-region not reported',
    crossRegionPendingReview: 'Cross-region pending review',
    crossRegionType: 'Cross-region Type',
    crossSubjectDeviceTip: 'This student’s device does not belong to a Franchisee under the same entity',
    crossSubjectExhaustTip: 'If the quota is exhausted, transferring cross-entity students will require approval from the Regional Master Franchisee',
    crossSubjectLimitExceeded: 'You have exceeded the maximum allowed cross-entity student limit and cannot proceed',
    crossSubjectPendingAudit: 'Application submitted. Please wait for approval before retrying',
    crossSubjectQuotaTip: 'Transferring this student will consume one cross-entity Instructor quota',
    crossSubjectRemainLimit: 'Remaining quota for cross-entity Instructor assignments this month:',
    crossSubjectTitle: 'Cross-entity Instruction',
    crossSubjectUnknown: 'Cross-entity validation result unknown. Please try again later',
    currentAuthArea: 'Current Authorized Region',
    currentServiceCenterId: 'Current Learning Center ID:',
    currentServiceCenterName: 'Current Learning Center Name:',
    customNameRequired: 'Name is required',
    customTable: 'Custom Table',
    customer: 'Search Customers',
    customerChannel: 'Customer Channel',
    leadsPickTimeRangeLabel: 'Claim Time Range',
    leadsPickTimeColumn: 'Claim Time',
    customerName: 'Customer Name',
    customerNameLabel: 'Customer Name:',
    customerNameOrPhone: 'Customer Name / Phone Number',
    customerNamePhone: 'Customer Name / Phone Number',
    customerPhone: 'Customer Phone Number',
    dachaxun: 'Promotion Ambassador Search:',
    dao: 'Visited Learning Center',
    dataValidate: 'Data Validation',
    dataValidateComplete: 'Data validation completed. Total {total} student leads',
    dataValidateError: 'Data errors: {error}. Please correct and try again',
    dataValidateFail: 'Data validation failed',
    pleaseSelectCompany: 'Please select company',
    machineRemarkTitle: 'Learning Tablet Remark',
    remarkPlaceholder: 'Please enter content',
    accountRebindTitle: 'Phone Number Rebinding',
    learningMachineAccountNo: 'Learning Tablet Account Number',
    learningMachineAccountLabel: 'Learning Tablet Account:',
    originalMobileLabel: 'Original Phone Number',
    newMobileLabel: 'New Phone Number',
    pleaseEnterOriginalMobile: 'Please enter original phone number',
    pleaseEnterNewMobile: 'Please enter new phone number',
    verifyCodeLabel: 'Verification Code:',
    pleaseEnterVerifyCode: 'Please enter verification code',
    resendAfterSeconds: 'Resend after {n} seconds',
    dataValidateResult: 'Errors: {error}, Duplicates: {repeat}, Valid: {pass}',
    day: 'Day',
    questionUnit: 'Questions',
    countUnit: '',
    scoreUnit: 'pts',
    lastStudyTimeLabel: 'Last Study Time: ',
    learningReportDateLabel: 'Report Date',
    dealerId: 'Franchisee ID',
    dealerInfo: 'Franchisee Information',
    dealerName: 'Franchisee Name',
    dealerNoQualification: 'This Franchisee does not have Learning Center qualification. Please register the location first',
    dealerParentAgentId: 'Upstream Master Franchisee ID',
    delete: 'Delete',
    deleteConfirmContent: 'After deletion, the Learning Center will no longer be able to use this image. Are you sure you want to delete it?',
    deleteConfirmDesc: 'Note: Activities that previously used this image will continue to display it. If there is any risk, please notify Learning Center principals to stop using it',
    deleteFailed: 'Delete failed',
    deleteImage: 'Delete Image',
    deleteSuccess: 'Deleted successfully',
    details: 'Details',
    detailLabel: 'Details',
    deviceSN: 'Device SN',
    differentModelCannotMerge: 'Products with different models or prices cannot be merged for exchange',
    dispatchedPrototypeCount: 'Shipped Demo Device Count',
    displayStatus: 'Display Status',
    downloadErrorFile: 'Download Error File',
    dragFileHereOr: 'Drag files here, or',
    edit: 'Edit',
    editExamInfo: 'Edit Exam Information',
    editFollowRecord: 'Edit Follow-up Record',
    editImage: 'Edit Image',
    editInfo: 'Edit Information',
    editProfileTitle: 'Edit Profile',
    editSchoolInfo: 'Edit School Information',
    editSuccess: 'Updated successfully',
    effectTime: 'Effective Time',
    endDate: 'End Date',
    enterExamInfoAtLeastOneYear: '(Enter at least one year of exam information)',
    enterExamInfoTitle: 'Enter Exam Information',
    entryAccountExperienceDate: 'Experience Date',
    entryAccountExperienceEndDate: 'Experience End Date',
    entryAccountExperienceStartDate: 'Experience Start Date',
    entryAccountLearningMachine: 'Learning Tablet',
    entryAccountOpenPerson: 'Activated By',
    entryAccountOpenTime: 'Activation Time',
    entryAccountPleaseEnterSnCode: 'Please enter Learning Tablet SN',
    entryAccountSearchCustomer: 'Search Customer',
    entryAccountSnCode: 'Learning Tablet SN',
    er: 'Grade 11',
    eryear: 'Grade 2',
    examInfoTipFeedback: 'If the school cannot be found, please contact support to request adding a new school',
    examProvinceCity: 'Province / City / District',
    examStageName: 'Education Stage',
    exceed10MLimit: 'File exceeds 10MB limit and cannot be uploaded',
    exceed20MLimit: 'File exceeds 20MB limit and cannot be uploaded',
    exceed5MLimit: 'File exceeds 5MB limit and cannot be uploaded',
    expand: 'Expand',
    experienceAccountLabel: 'Experience Account:',
    experienceAccountPasswordLabel: 'Experience Account Password:',
    experienceAnalystLabel: 'Experience Analyst:',
    experienceAnalyst: 'Experience Analyst',
    inviteExperienceDetailAccountLabel: 'Account:',
    inviteExperienceDetailPasswordLabel: 'Password:',
    inviteExperienceDetailDateLabel: 'Experience Date:',
    inviteExperienceDetailCourseLabel: 'Experience Course:',
    inviteExperienceDetailFenyuanLabel: 'Analyst:',
    experienceDateFormat: 'yyyy-MM-dd',
    experienceInProgress: 'In Experience',
    experienceQuotaExhausted: 'Experience quota exhausted',
    experienceStartDateLabel: 'Experience Start Date:',
    experienceSuccess: 'Experience successful',
    expired: 'Expired',
    exportCurrentDetail: 'Export Current Details',
    exportDetail: 'Export Details',
    exportSuccess: 'Export successful',
    fail: 'Failed',
    familyMember1: 'Family Member 1:',
    familyMember1Label: 'Family Member 1',
        familyMember1FormLabel: 'Family Member 1:',
    familyMember1LabelShort: 'Family Member 1:',
    familyMember2: 'Family Member 2:',
    familyMember2Label: 'Family Member 2',
        familyMember2FormLabel: 'Family Member 2:',
    familyMember2LabelShort: 'Family Member 2:',
    female: 'Female',
    fen: 'Above 40',
    fenlei: 'Category',
    fenshu: 'Score Improvement',
    fenxiaoyuan: 'Sales Rep',
    pleaseSelectDistributor: 'Please select Sales Rep',
    fenyuan: 'Analyst',
    fileAddFail: 'Failed to add file',
    fileName: 'File Name',
    fileSizeExceed1MB: 'File size cannot exceed 1MB',
    fileSizeExceed5M: 'File size cannot exceed 5MB',
    fillCompleteExamInfo: 'Please complete all exam information',
    fillCreateInfo: 'Fill in creation information',
    finalScoreCannotExceedTotal: 'Final score cannot exceed subject total score',
    finalScoreGtEnrollment: 'Final score must be greater than admission score',
    finalScoreLteTotal: 'Final score cannot exceed subject total score',
    finishTime: 'Completion Time',
    finisher: 'Completed By',
    flyerHeadPic: 'Flyer Header Image:',
    follow: 'Follow-up Owner',
    followAction: 'Follow-up',
    followContentRequired: 'Follow-up content is required',
    followDesc: 'Follow-up Description:',
    followFail: 'Follow-up failed',
    followInfo: 'Follow-up Information',
    followLabel: 'Follow-up:',
    followPerson: 'Follow-up Owner:',
    followPersonLabelShort: 'Follow-up Owner:',
    followPersonRequired: 'Follow-up Owner is required',
    followRecord: 'Follow-up Records',
    followRemindTitle: 'Follow-up Reminder',
    followStatusLabel: 'Follow-up Status:',
    followSuccess: 'Follow-up successful',
    followType: 'Follow-up Type:',
    followUpSuccess: 'Follow-up successful',
    followUpMgmt_totalFollow: 'Total Follow-ups',
    followVoucherLabel: 'Follow-up Evidence:',
    frozen: 'Frozen',
    fulltimeLabel: 'Full-time',
    galleryTypeColon: 'Type:',
    genderLabel: 'Gender:',
    gender: 'Gender',
        genderFormLabel: 'Gender:',
    getRecycleCountFail: 'Failed to retrieve recycle count',
    getTemplateInfoFail: 'Failed to retrieve template information',
    getTodayCountFailed: 'Failed to retrieve today’s available claim count',
    goToPerfect: 'Complete Now',
    gotIt: 'Got it',
    grade: 'Grade Level',
    gradeLabel: 'Grade:',
    gradeLabelShort: 'Grade:',
    gradeRequired: 'Grade is required',
    grantPass: 'Issue Pass',
    grantReasonLabel: 'Reason for Issuance:',
    grantSuccess: 'Issued successfully',
    growthReport: 'Growth Report',
    handleLater: 'Handle later',
    hantianOutcall: 'Hantian Outbound Calls',
    haohour: 'Enter time',
    homeAddress: 'Home Address:',
    homeAddressLabel: 'Home Address:',
    hour: 'Report Start Time',
    houryici: 'Use previous parameters directly',
    howToGetMore: 'How to get more examples?',
    hua: 'Call Recording',
    huashi: 'Call Duration',
    identity: 'Identity:',
    imageAddFailed: 'Failed to add image',
    imageDelete: 'Delete Image',
    imageDeleteFail: 'Failed to delete image',
    imageDeleteSuccess: 'Image deleted successfully',
    imageExceed5M: 'Image exceeds 5MB. Please compress before uploading',
    imageFormatJpgJpegPng: 'Only JPG, JPEG, PNG formats are supported',
    imageFormatJpgPng: 'Only JPG/PNG formats are supported',
    imageFormatJpgPngGif: 'Only JPG/PNG/GIF formats are supported',
    imageFormatOnlyJpgPng: 'Only JPG and PNG formats are supported',
    imageFormatTip: 'Supports JPG/PNG formats',
    imageMaterial: 'Image Materials',
    imageMax6Count: 'You can upload up to 6 images',
    imageMax9Count: 'You can upload up to 9 images',
    imageNoDuplicate: 'Duplicate images are not allowed',
    imageOffShelf: 'Remove Image from Listing',
    imagePublish: 'Publish Image',
    imageSizeExceed10M: 'Image exceeds 10MB limit and cannot be uploaded',
    imageSizeExceeded: 'Image size cannot exceed 20MB',
    imageSizeTip: '*Recommended width: 1080 × 600. Click image to add markers',
    importComplete: 'Import completed',
    importCountTip: 'Only newly added leads are counted',
    importDetail: 'Import Details',
    importErrorTip: 'Some data contains errors. If you proceed, invalid data will not be imported',
    importErrorTitle: 'Warning: Data errors remain',
    importTime: 'Import Time',
    importedCount: 'Imported',
    inactive: 'Inactive',
    insertText: 'Insert Text',
    intentLevel: 'Intent Level:',
    intentLevelColumn: 'Intent Level',
    intentLevelChangeSuccess: 'Intent level updated successfully',
    intentLevelLabel: 'Intent Level:',
    invalidVideoDuration: 'Invalid video duration',
    invalidVideoFormat: 'Invalid video format',
    textxdis: 'Student Homework',
    textl0nm: 'More',
    textaq54: 'Marked successfully',
    text4pq7: 'View Answer Records',
    texth0qa: 'Click to upload',
    textf3rq: 'Invitation successful!',
    inviteFailed: 'Invitation failed',
    inviteKnowledgeVulnExamSuccess: 'Knowledge Diagnostic invitation successful',
    inviteKnowledgeVulnExamTime: 'Knowledge Diagnostic Appointment Time',
    inviteLocation: 'Invitation Location',
        inviteLocationLabel: 'Invitation Location:',
    inviteDetail: 'Invitation Details',
    invitePhysicalExamTime: 'Knowledge Diagnostic Appointment Time',
    inviteRewardTier2MoreThanTier1: 'Tier 2 invitations must exceed Tier 1',
    inviteRewardTier3MoreThanTier2: 'Tier 3 invitations must exceed Tier 2',
    inviteRewardTier4MoreThanTier3: 'Tier 4 reward must exceed Tier 3',
    inviteStudentTransfer: 'Invite Student Transfer',
    inviteSuccess: 'Invitation successful',
    inviteSuccessExclaim: 'Invitation successful!',
    inviteSuccessTip: 'Knowledge Diagnostic invitation successful',
    inviteTransfer: 'Invite Transfer',
    inviteType: 'Invitation Type:',
    ip: 'IP',
    isMultiSelect: 'Allow Multiple Selection',
    isMultiSelectColumn: 'Multi-select Enabled',
    isReported: 'Reported',
    itemsUnit: 'items',
    labelColon: 'Label:',
    lastCommunicateTime: 'Last Follow-up Time',
    lastFollowTime: 'Last Follow-up Time',
    lastUpdateTime: 'Last Updated Time',
    lastUpdateUser: 'Last Updated By',
    latitude: 'Latitude',
    leadAssignTime: 'Lead Assignment Time',
    leadCreateTime: 'Lead Creation Time',
    leadDetailTitle: 'Lead Details',
    leadIdentity: 'Lead Identity:',
    leadInfo: 'Lead Information',
    leadInfoSettingsLabel: 'Lead Info Settings',
    shareRuleSettingsLabel: 'Sharing Rule Settings',
    leadMarkFailedSelectReason: 'Lead marking failed. Please select a reason',
    leadName: 'Lead Name:',
    leadNameColumn: 'Lead Name',
        leadNameColumnLabel: 'Lead Name:',
    leadNameRequired: 'Lead name is required',
    leadPhone: 'Lead Phone Number:',
    leadPhoneAutoMatch: 'User information has been auto-matched based on the phone number provided',
    leadRatio: 'Lead Ratio',
    leadSourceLabel: 'Lead Source:',
    learnCenterAccount: 'Learning Center Account',
    length2To10: 'Please enter 2–10 characters',
    liang: 'Favorites Count',
    loadFailed: 'Load failed',
    loadSearchResultFail: 'Failed to load search results. Please try again later',
    locationSource: 'Location Source',
    longTermTempPass: 'Long-term Temporary Pass',
    longitude: 'Longitude',
    ma: 'SN Code',
    machineAccount: 'Learning Tablet Account',
    machineAccountLabel: 'Learning Tablet Account:',
    machineConversionNum: 'Learning Tablet Conversions',
    machineConversionRate: 'Learning Tablet Conversion Rate',
    machineConversionRatio: 'Learning Tablet Conversion Ratio',
    machineManageAccount: 'Learning Tablet Management Account',
    machineSNCodeLabel: 'Learning Tablet SN:',
    male: 'Male',
    markAsCase: 'Mark as Case',
    markFailedSuccess: 'Marked as invalid successfully',
    leadInvalidConfirmTip: 'Once marked as invalid, this lead will no longer appear in the lead list. Do you want to proceed?',
    markInvalidFail: 'Failed to mark as invalid',
    markInvalidSuccess: 'Marked as invalid successfully',
    markPrototype: 'Mark as Demo Device',
    markSuccess: 'Marked successfully',
    markSupervisorInfo: 'Mark Instructor Information',
    markSupervisorStatusBtn: 'Mark Instructor Status (Original Service Owner)',
    markSupervisorStatusTooltip: 'After marking the student’s Instructor status, Analysts can filter and compare student performance under different statuses',
    markSupervisorTooltipExpired: 'Supervision expired: Once the validity period ends, the system will automatically update the status',
    markSupervisorTooltipExpiring: 'Supervision Expiring Soon: 14 days remaining',
    markSupervisorTooltipNone: 'No supervision: The Learning Center currently does not provide Instructor services',
    markSupervisorTooltipOnlineOnly: 'Online Only: Not enrolled in study room; Instructor support is provided online',
    markSupervisorTooltipStudyRoom: 'Study Room: The student is enrolled in the offline study room',
    markSupervisorTooltipUnmarked: 'Unmarked: No Instructor status assigned yet',
    markedPrototypeCount: 'Marked Demo Device Count (by Model)',
    markerPositionExists: 'A marker already exists at this position. Please choose another location',
    materialInterpretation: 'Material Interpretation',
    materialInterpretationPlaceholder: 'Enter interpretation (max 500 characters)',
    materialPreview: 'Material Preview',
    materialSort: 'Material Sorting',
    max20Chars: 'Maximum 20 characters',
    max28Chars: 'Maximum 28 characters',
    max50Chars: 'Maximum 50 characters',
    max5FilesUpload: 'You can upload up to 5 files (images or PDFs)',
    maxTwoExamScores: 'Select up to two exam scores',
    min: 'Form Header Category Format',
    minhour: 'Course Allocation Time',
    minmin: 'Pagination Section Above',
    minutesUnit: 'Minutes',
    mobile: 'Phone Number',
    modifySuccess: 'Updated successfully',
    month: 'Month-over-Month',
    monthRemainLimit: 'Remaining this month:',
    monthlyRemainLimitTip: 'Remaining experience quota this month: {remain}. This invitation will consume 1 quota',
    moreActions: 'More',
    my: 'My',
    myLeads: 'My Leads',
    myServiceLoadFail: 'Failed to load my customer service',
    name: 'Name',
    nameColon: 'Name:',
    nameLabel: 'Name',
    newActivated: 'Newly Activated',
    newLead: 'New Lead',
    nextFollowTime: 'Next Follow-up Time:',
    no: 'No',
    noFollowNeeded: 'No Follow-up Needed',
    noGrayscale: 'No Grayscale',
    noLimit: 'No Limit',
    noMoreShareTarget: 'No more share targets',
    shareTarget: 'Share Target',
    shareTargetNotSpecified: 'No share target specified',
    noPass: 'No Pass',
    noProvinceCrossRegion: 'No Cross-region at Province/City Level',
    noRelatedInfoFound: 'No related information found',
    noSuitableReasonTip: 'If no suitable reason is available, you can configure it in Rule Settings',
    /** Mark invalid: fixed tagCode 1–7 (ERROR_TAG_INIT_*). US UI uses only this set, not ad‑hoc API names. */
    lapseInvalidReason1: 'No answer / powered off / out of service',
    lapseInvalidReason2: 'Wrong or invalid number',
    lapseInvalidReason3: 'Parent or child not interested',
    lapseInvalidReason4: "Child's stage/grade doesn't match",
    lapseInvalidReason5: 'Not the parent/guardian',
    lapseInvalidReason6: 'Already a won customer',
    lapseInvalidReason7: 'Already purchased a competitor',
    noTransferApply: 'No transfer applications at the moment',
    noValidUploadData: 'No valid data to upload',
    noVirtualPhoneForLead: 'Virtual phone numbers are not allowed for creating leads',
    nonCompliant: 'Non-compliant',
    none: 'None',
    notFilled: 'Not filled',
    notFilledFollowContent: 'Follow-up content not filled',
    notSure: 'Not sure',
    numberMax99: 'Please enter an integer between 1 and 99',
    offShelfSuccess: 'Removed from listing successfully',
    onShelf: 'Publish',
    onlyOneFile: 'Only one file can be uploaded',
    onlyXlsFormat: 'Only .xls files are supported',
    onlyXlsXlsxFormat: 'Only .xls/.xlsx files are supported',
    entryQuotaLabel: 'Entry Account Quota:',
    entryOpenCustomerLabel: 'Activated Customer:',
    entryCustomerPlaceholder: 'Enter phone number or name',
    entryNoCustomerFound: 'No customer found',
    entryExperienceValidityLabel: 'Experience Validity:',
    entryLearningMachineLabel: 'Learning Tablet:',
    entryMachinePlaceholder: 'Model or SN of Learning Tablet',
    entryNoMachineFound: 'No Learning Tablet found',
    entryOpenSuccessTitle: 'Entry Account Activated Successfully',
    entryCustomerAccountLabel: 'Customer Account',
    entryPasswordLabel: 'Password',
    openExperience: 'Activate Experience',
    openExperienceAccount: 'Activate Experience Account',
    openExperienceAccountSuccess: 'Experience account activated successfully',
    openExperienceFailed: 'Failed to activate experience',
    openService: 'Activate Service',
    operationFail: 'Operation failed',
    operationFailed: 'Operation failed. Please try again later',
    operationModeLabel: 'Operation Mode:',
    operationType: 'Operation Type',
    operationTypeImport: 'Import',
    operationTypeTip1: 'If the uploaded file only creates new leads, the operation type is Import',
    operationRecord: 'Records',
    operationTypeTip2: 'If the uploaded file only updates existing leads, the operation type is Update',
    operationTypeTip3: 'If the uploaded file both updates existing leads and creates new leads, the operation type is Update',
    operationTypeUpdate: 'Update',
    optional: 'Optional',
    sipOptionalTip: 'SIP number used (optional, required when updating SIP number)',
    orderName: 'Order Name',
    orderNo: 'Order Number',
    orderPayAmount: 'Order Amount',
    orderPayUser: 'Ordered by',
    orderStatus: 'Order Status',
    orderTime: 'Order Time',
    orderType: 'Order Type',
    addOrderRecord: 'Add Order Record',
    dealDetail: 'Deal Details',
    addOrder: 'Add Order',
    editOrder: 'Edit Order',
    learningMachineNewSign: 'New Learning Tablet Order',
    supervisionNewSign: 'New Instructor Service Order',
    supervisionRenew: 'Instructor Service Renewal',
    learningMachineNewSignAmount: 'Learning Tablet New: ¥{amount}',
    supervisionNewSignAmount: 'Instructor New: ¥{amount}',
    supervisionRenewAmount: 'Instructor Renewal: ¥{amount}',
    learningMachineInfo: 'Learning Tablet Information',
    learningMachineInfoLabel: 'Learning Tablet Info:',
    modelLabel: 'Model:',
    smartAccountLabel: 'Smart Account:',
    pleaseEnterManagerMobileOrSn: 'Please enter admin phone number or SN',
    operationTip: 'Operation Tip',
    confirmDeleteOrder: 'Are you sure you want to delete this order?',
    fillSplitRatioTip: 'Please fill in the split ratio for {userName}',
    splitRatioMustBe100: 'Current split ratio is {ratio}%, please maintain 100%',
    me: 'Me',
    other: 'Other',
    otherInfo: 'Other Information',
    outboundExpiredCannotRenew: 'Your service has expired and cannot be renewed. Please activate the service again',
    outboundNotOpened: 'Outbound service is not activated. Please activate it before recharging',
    outboundOpening: 'Your outbound service is being activated. It is expected to be completed within 7 working days after placing the order. Please recharge after activation',
    ownerTime: 'Assignment Time',
    packageRemainingMinutes: 'Remaining Minutes in Package',
    parentAgentId: 'Upstream Master Franchisee ID',
    parentAgentName: 'Upstream Master Franchisee Name',
    participationExportFilename: 'Participation Export {time}.xls',
    participationPageTitle: 'Activity Participation',
    passHolding: 'Pass Active',
    passStatusLabel: 'Pass Status:',
    passportStatus: 'Pass Status',
    passportStatusNone: 'Not Held',
    passportStatusTemp: 'Temporary Pass Active',
    paySettings: 'Payment Settings',
    paymentFail: 'Payment failed',
    pending: 'Pending',
    pendingAllocate: 'Pending Allocation',
    pendingFollow: 'Pending Follow-up',
    pendingPublish: 'Pending Publish',
    inProgress: 'In Progress',
    paused: 'Paused',
    ended: 'Ended',
    downloadActivityQRCode: 'Download Activity QR Code',
    pauseActivity: 'Pause Activity',
    pause: 'Pause',
    startActivity: 'Start Activity',
    start: 'Start',
    activityPreview: 'Activity Preview',
    activityParticipationDetail: 'Participation Details',
    activityEdit: 'Edit Activity',
    publishActivityTip: 'Once published, students can view and participate in the activity. Confirm to publish?',
    publishActivityTitle: 'Publish Activity',
    publishSuccessTip: 'You can download the QR code to promote the activity or view participation details in the activity list',
    publishSuccessTitle: 'Activity Published Successfully',
    confirmDeleteActivityTip: 'Are you sure you want to delete this activity?',
    activityDeleteTitle: 'Delete Activity',
    confirmPasswordLabel: 'Confirm Password:',
    confirmPauseActivityTip: 'Are you sure you want to pause this activity?',
    confirmActivityToggleTip: 'Are you sure you want to {action} this activity?',
    confirmStartActivityTip: 'Are you sure you want to start this activity?',
    perfectSuccess: 'Completed successfully',
    perfectUserProfile: 'Complete User Profile',
    person: 'Person',
    phoneBillBalance: 'Phone Balance',
    phoneLabel: 'Phone Number:',
    phoneNotVerified: 'The customer’s phone number has not been verified',
    picture: 'Image',
    planTime: 'Planned Time',
    pleaseAddRepairDetail: 'Please add repair details',
    pleaseAddStudentStory: 'Please add student story',
    pleaseCheckOutboundProtocol: 'Please read and agree to the outbound service agreement first',
    pleaseCompleteUserProfile: 'Please complete the user profile first',
    pleaseEditStudentScore: 'Please edit the student score',
    pleaseEnter: 'Please enter Activity ID',
    pleaseEnter4DigitCode: 'Please enter a 4-digit verification code',
    pleaseEnterActivityDesc: 'Please enter activity description',
    pleaseEnterActivityPrize: 'Please enter activity prize',
    pleaseEnterActivityRules: 'Please enter activity rules',
    pleaseEnterActivityTag: 'Please enter activity tag',
    pleaseEnterActivityTitle: 'Please enter activity title',
    pleaseEnterAdapAccount: 'Please enter adaptive account',
    pleaseEnterAgencyAddress: 'Please enter organization address',
    pleaseEnterAgencyContact: 'Please enter organization contact',
    pleaseEnterAgencyIntro: 'Please enter organization introduction',
    pleaseEnterAgencyName: 'Please enter organization name',
    pleaseEnterApplyReason: 'Please enter application reason',
    pleaseEnterApplySuccessMsg: 'Please enter success message after registration',
    pleaseEnterApplySuccessReminder: 'Please enter success reminder after registration',
    pleaseEnterBriefIntro: 'Please enter a brief introduction',
    pleaseEnterButtonName: 'Please enter button name',
    pleaseEnterCancelReason: 'Please enter cancellation reason',
    pleaseEnterCaseTitle: 'Please enter case title',
    campusCaseCreatorLabel: 'Student Location',
    campusCaseCreatorPlaceholder: 'Please select state/city',
    campusCaseLabelSubject: 'Subject:',
    campusCaseLabelProgressScore: 'Progress Score:',
    campusCaseLabelEnrolScore: 'Enrollment Score:',
    campusCaseSortTitleWithColon: 'Sort:',
    campusCaseFilterResultBefore: 'Current results:',
    campusCaseFilterResultAfter: '',
    campusCaseFilterCollapse: 'Collapse Options',
    campusCaseFilterMore: 'More Options',
    pleaseEnterCatalogName: 'Please enter category name',
    pleaseEnterCatalogSort: 'Please enter category order',
    pleaseEnterCategoryName: 'Please enter a valid category name',
    pleaseEnterContact: 'Please enter contact name',
    pleaseEnterContactMethod: 'Please enter contact method',
    pleaseEnterContactNumber: 'Please enter a contact number for users',
    pleaseEnterCorrectAmount: 'Please enter a valid amount',
    pleaseEnterCorrectCustomerInfo: 'Please enter valid customer information',
    pleaseEnterCorrectMachineInfo: 'Please enter valid Learning Tablet information',
    learningMachineInfoInvalid: 'The Learning Tablet information is invalid',
    pleaseEnterCorrectPeriod: 'Please enter a valid period',
    pleaseEnterCorrectPhone: 'Please enter a valid phone number',
    pleaseEnterCorrectSN: 'Please enter a valid SN code',
    pleaseEnterCounterAddress: 'Please enter counter address',
    pleaseEnterCounterManagerPhone: 'Please enter counter manager phone number',
    pleaseEnterDescription: 'Please enter description',
    pleaseEnterDetailAddress: 'Please enter detailed address',
    pleaseEnterDeviceSN: 'Please enter device SN code',
    pleaseEnterEnrollmentScore: 'Please enter enrollment score',
    pleaseEnterFamilyMember1Phone: 'Please enter Family Member 1 phone number',
    pleaseEnterFamilyMember2Phone: 'Please enter Family Member 2 phone number',
    pleaseEnterFamilyMemberPhone: 'Please enter Family Member {n} phone number',
    pleaseEnterFinalScore: 'Please enter final score',
    pleaseEnterFollowContent: 'Please enter follow-up content',
    pleaseEnterFollowType: 'Please enter follow-up type',
    pleaseEnterHandwrittenEssay: 'Please enter handwritten essay',
    pleaseEnterHomeAddress: 'Please enter home address',
    pleaseEnterImageName: 'Please enter image name',
    pleaseEnterInviteLocation: 'Please enter invitation location',
    pleaseEnterLeadName: 'Please enter lead name',
    pleaseEnterLeadNameOrPhone: 'Please enter lead name or phone number',
    pleaseEnterLearningMachineInfo: 'Please enter Learning Tablet information',
    pleaseEnterLearningMachineSn: 'Please enter Learning Tablet SN',
    pleaseEnterLeftTitle: 'Please enter left title',
    pleaseEnterLegalName: 'Please enter legal name',
    pleaseEnterMachineAccount: 'Please enter Learning Tablet account',
    materialNameLabel: 'Material Name',
    pleaseEnterMaterialName: 'Please enter material name',
    pleaseEnterMaterialSort: 'Please enter material order',
    pleaseEnterMonthNum: 'Please enter the number of months first',
    pleaseEnterName: 'Please enter name',
    pleaseEnterNameOrPhone: 'Please enter name or phone number',
    pleaseEnterNamePlaceholder: 'Please enter {type} name',
    pleaseEnterNameRule: 'Please enter Chinese characters, numbers, letters, underscores, or dots',
    pleaseEnterNewPhone: 'Please enter new phone number',
    pleaseEnterNewStudentName: 'Please enter new student name',
    pleaseEnterNotice: 'Please enter notice',
    pleaseEnterOriginalPhone: 'Please enter original phone number',
    pleaseEnterPageDesc: 'Please enter page description',
    pleaseEnterPageName: 'Please enter page name',
    pleaseEnterPassword: 'Please enter password',
    pleaseEnterPassword6_32: 'Please enter a password (6–32 letters and numbers)',
    pleaseEnterPhone: 'Please enter phone number',
    pleaseEnterPhoneFirst: 'Please enter phone number first',
    pleaseEnterPromoterName: 'Please enter promoter name',
    pleaseEnterQrCodeIntro: 'Please enter QR code description',
    pleaseEnterReason: 'Please enter reason',
    pleaseEnterReason5to100: 'Please enter reason (5–100 characters)',
    pleaseEnterReceiverPhone: 'Please enter receiver phone number',
    pleaseEnterRegistrationInfo: 'Please enter registration information',
    pleaseEnterRejectReason: 'Please enter rejection reason',
    pleaseEnterSNOrTimeToExport: 'Please enter SN or select creation time before exporting',
    pleaseEnterSchoolName: 'Please enter school name',
    pleaseEnterServiceCenterName: 'Please enter service center name',
    pleaseEnterShipAddress: 'Please enter shipping address',
    pleaseEnterStoreName: 'Please enter store name',
    pleaseEnterStudentAccountFirst: 'Please enter student account first',
    pleaseEnterStudentAccountOrName: 'Please enter student account or name',
    pleaseEnterStudentNameOrPhone: 'Please enter student name or phone number',
    pleaseEnterStudentName: 'Please enter student name',
    pleaseEnterStudentPhone: 'Please enter student phone number',
    pleaseEnterStudentScoreInfo: 'Please enter student score information',
    pleaseEnterSubjectTotalScore: 'Please enter total subject score',
    pleaseEnterSupervisorFee: 'Please enter Instructor fee',
    pleaseEnterTemplateName: 'Please enter template name',
    pleaseEnterTemplateNameSearch: 'Please enter template name',
    pleaseEnterTitle: 'Please enter title',
    pleaseEnterUser: 'Please enter user',
    pleaseEnterValidAdaptiveAccount: 'Please enter a valid adaptive account',
    pleaseEnterValidContactNumber: 'Please enter a valid contact number',
    pleaseEnterValidNumber: 'Please enter a valid number',
    pleaseEnterValidPhone: 'Please enter a valid phone number',
    pleaseEnterValidPhoneNum: 'Please enter a valid phone number',
    pleaseEnterValidRechargeAmount: 'Please enter a valid recharge amount',
    pleaseEnterVerifyAddress: 'Please enter verification address for the experience card',
    pleaseFill2_50Chars: 'Please enter 2–50 characters',
    pleaseFillActivityDesc: 'Please enter activity description',
    pleaseFillActivityName: 'Please enter activity name',
    pleaseFillActivityRules: 'Please enter activity rules',
    pleaseFillActivityTitle: 'Please enter activity title',
    pleaseFillAdaptiveAccount: 'Please provide adaptive account',
    pleaseFillAdaptiveAccountShort: 'Please provide a complete adaptive account',
    pleaseFillAgencyAddress: 'Please enter organization address',
    pleaseFillAgencyContact: 'Please enter organization contact number',
    pleaseFillAgencyIntro: 'Please enter organization introduction',
    pleaseFillCaseSettingsFirst: 'Please complete case settings first',
    pleaseFillFollowContent: 'Please enter follow-up content',
    pleaseFillInviteRewardRule: 'Please complete the Tier 1 invite reward rule',
    pleaseFillMarkerContent: 'Please enter marker content',
    pleaseFillProgressPlan: 'Please enter progress plan',
    pleaseFillRemarkFirst: 'Please enter remark first',
    pleaseFillShareRatio: 'Please enter {name} allocation ratio',
    pleaseEnterShareRatio: 'Please enter allocation ratio',
    pleaseFillStoreRewardRule: 'Please complete the Tier 1 in-store reward rule',
    pleasePerfectUserProfileFor: 'Please complete {name}’s user profile first',
    pleasePerfectUserProfileSimple: 'Please complete the user profile',
    pleaseSearchAccount: 'Please search for account',
    pleaseSelect: 'Please select',
    pleaseSelectAccountStatus: 'Please select account status',
    pleaseSelectActivityEndTime: 'Please select activity end time',
    pleaseSelectActivityFollower: 'Please select activity owner',
    pleaseSelectActivityStartTime: 'Please select activity start time',
    pleaseSelectActivityTime: 'Please select activity time',
    pleaseSelectAgent: 'Please select Master Franchisee',
    pleaseSelectAgentFirst: 'Please select the Master Franchisee first',
    pleaseSelectAnalyst: 'Please select Analyst',
    pleaseSelectAssignAnalyst: 'Please select assigned Analyst',
    pleaseSelectAssignPerson: 'Please select assigned person',
    pleaseSelectBgColor: 'Please select background color',
    pleaseSelectBusinessStatus: 'Please select business status',
    pleaseSelectCallStatus: 'Please select call status',
    pleaseSelectCatalog: 'Please select category',
    pleaseSelectChangeReason: 'Please select change reason',
    pleaseSelectChannel: 'Please select channel',
    pleaseSelectCounterType: 'Please select counter type',
    pleaseSelectCrossRegionType: 'Please select cross-region type',
    pleaseSelectCustomerChannel: 'Please select customer channel',
    pleaseSelectDate: 'Please select date',
    pleaseSelectDeviceToSelected: 'Please move a device to the selected area',
    pleaseSelectDisplayStatus: 'Please select display status',
    pleaseSelectDoubleOrder: 'Please select whether to enable double order',
    pleaseSelectEnrollmentGrade: 'Please select enrollment grade',
    pleaseSelectExchangeIn: 'Please select exchange-in product',
    pleaseSelectExchangeOut: 'Please select exchange-out product',
    pleaseSelectExperienceDate: 'Please select experience date',
    pleaseSelectFamilyMemberRelation: 'Please select Family Member {n} relationship',
    pleaseSelectFileType: 'Please select file type',
    pleaseSelectFirstLevelTag: 'Please select primary tag',
    pleaseSelectFollowPerson: 'Please select follow-up person',
    pleaseSelectFollowStatus: 'Please select follow-up status',
    pleaseSelectFollower: 'Please select follow-up person',
    pleaseSelectGradeFirst: 'Please select grade first',
    pleaseSelectIdentityType: 'Please select identity type',
    pleaseSelectIntentLevel: 'Please select intent level',
    pleaseSelectInvalidReason: 'Please select invalid reason',
    pleaseSelectInviteDate: 'Please select invitation date',
    pleaseSelectInviteType: 'Please select invitation type',
    inviteBigExamSuccessDialogTitle: 'Knowledge Diagnostic',
    inviteBigExamSuccessTopic: 'Knowledge diagnostic invitation sent successfully',
    inviteBigExamAppointmentTimeLabel: 'Diagnostic appointment time',
    inviteBigExamKnow: 'Got it',
    pleaseSelectInviter: 'Please select follow-up person',
    pleaseSelectIsMultiSelect: 'Please select whether multiple selection is allowed',
    pleaseSelectLabel: 'Please select label',
    pleaseSelectLocation: 'Please select location',
    pleaseSelectOperationMode: 'Please select operation mode',
    pleaseSelectOperator: 'Please select operator',
    pleaseSelectOrderSplitType: 'Please select order allocation type',
    orderSplitType: 'Order Allocation',
    independentComplete: 'Independent',
    collaborationSplit: 'Collaborative Allocation',
    pleaseSelectOrderStatus: 'Please select order status',
    pleaseSelectOrderType: 'Please select order type',
    pleaseSelectPageCategory: 'Please select page category',
    pleaseSelectPassStatus: 'Please select pass status',
    pleaseSelectPerson: 'Please select person',
    pleaseSelectPrincipal: 'Please select person in charge',
    pleaseSelectPrototypeType: 'Please select Demo Device type',
    pleaseSelectProvinceCity: 'Please select state/city',
    pleaseSelectQuota: 'Please select quota',
    pleaseSelectRankTime: 'Please select ranking time',
    pleaseSelectRealNameStatus: 'Please select real-name verification status',
    pleaseSelectRecycleReason: 'Please select recycle reason',
    pleaseSelectRegistrationInfo: 'Please select registration settings',
    pleaseSelectReportActivateArea: 'Please select activation region',
    pleaseSelectReviewResult: 'Please select review result',
    pleaseSelectScheduleDate: 'Please select appointment date',
    pleaseSelectScheduleTime: 'Please select appointment time',
    pleaseSelectSchool: 'Please select school',
    pleaseSelectServicePerson: 'Please select service person',
    pleaseSelectShipStatus: 'Please select shipping status',
    pleaseSelectShipWarehouse: 'Please select shipping warehouse',
    pleaseSelectSigningParty: 'Please select signing entity',
    pleaseSelectSoftwareActiveStatus: 'Please select software activation status',
    pleaseSelectSource: 'Please select source',
    pleaseSelectStage: 'Please select stage',
    pleaseSelectStageExam: 'Please select academic stage',
    pleaseSelectStageFirst: 'Please select stage first',
    pleaseSelectStartEndTime: 'Please select start and end time',
    pleaseSelectStudent: 'Please select student',
    pleaseSelectStudentToClaim: 'Please select students to claim first',
    pleaseSelectStudyTime: 'Please select study time',
    pleaseSelectSubject: 'Please select subject',
    pleaseSelectSyncCourseStatus: 'Please select sync course status',
    pleaseSelectTagType: 'Please select tag type',
    pleaseSelectTemplateStatus: 'Please select template status',
    pleaseSelectTemplateType: 'Please select activity template type',
    pleaseSelectTestConfirmTime: 'Please select test confirmation time',
    pleaseSelectTestStatus: 'Please select test status',
    pleaseSelectVisitStore: 'Please select store visited',
    pleaseSelectYear: 'Please select year',
    pleaseSetActivitySpecifiedTime: 'Please set the specific activity time',
    pleaseSetActivityTime: 'Please set activity time',
    pleaseSetQueryFirst: 'Please set query conditions first',
    pleaseStartOutboundFirst: 'Please click "Start Outbound" in the top right corner before making calls',
    pleaseUploadAgreement: 'Please upload the agreement before saving',
    pleaseUploadFaultImage: 'Please upload fault image',
    pleaseUploadFile: 'Please upload file',
    pleaseUploadFileImagePdf: 'Please upload file (image or PDF supported)',
    pleaseUploadFirstDiagnosisMedia: 'Please upload initial diagnosis image/video',
    pleaseUploadImage: 'Please upload image',
    pleaseUploadImageFormat: 'Invalid image format. Please upload JPG/PNG/JPEG files',
    pleaseUploadInspectionMedia: 'Please upload inspection image/video',
    pleaseUploadMaterial: 'Please upload material',
    pleaseUploadParentFeedback: 'Please upload parent feedback',
    pleaseUploadVideo: 'Please upload video',
    pleaseUploadVideoFormat: 'Please upload video in MP4/MOV format',
    pleaseVerifyDeviceSn: 'Please verify device SN first',
    previewImage: 'Preview Image',
    previewTemplateTitle: 'Marketing Activity Template Preview',
    pleaseEnterProductName: 'Please enter product name',
    profileComplete: 'Completed',
    profileIncomplete: 'Incomplete',
    promisedVisitTime: 'Promised Visit Time:',
    promisedVisitTip: 'The time the customer promised to visit the store',
    promoteCount: 'Promoted Units',
    prototypeNote1: '1. Once a Learning Tablet is marked as a Demo Device, it cannot be modified',
    prototypeNote2: '2. Demo Devices cannot be sold and are for display and trial use only',
    prototypeNote3: '3. Each Demo Device can be linked to only one learning account',
    prototypeNote3Sub: 'If multiple accounts are linked, you must select one to keep; others will be unbound from the Learning Tablet',
    prototypeNoteLabel: 'Note:',
    prototypeProductModelLabel: 'Product Model:',
    prototypeSNCode: 'Demo Device SN',
    prototypeTypeLabel: 'Demo Device Type:',
    prototypeDispatchedCountLabel: 'Dispatched Demo Devices:',
    prototypeMarkedCountLabel: 'Marked Demo Devices (by Model):',
    prototypeAvailableCountLabel: 'Available Demo Devices for Marking:',
    prototypeRenewal: 'Demo Device Account Renewal',
    prototypeRenewalApply: 'Apply for Demo Device Account Renewal',
    prototypeType: 'Demo Device Type',
    provinceCity: 'State/City',
    provinceCityLabel: 'State/City:',
    publicPool: 'Public Pool',
    publicSchoolStage: 'Public School Stage',
    publishFailed: 'Publish failed',
    purchaseSuccess: 'Purchase successful',
    qi: 'Grace Period',
    qrcodeGenerateFail: 'Failed to generate QR code. Please try again',
    qu: 'Recipient',
    queryFailed: 'Query failed',
    queryFollowRemindFail: 'Failed to retrieve follow-up reminders',
    queryLearningTrackFail: 'Failed to retrieve student learning records',
    queryProgressScoreFail: 'Failed to retrieve progress score',
    queryScoreFail: 'Failed to retrieve scores',
    querySuccess: 'Query successful',
    quickFilter: 'Quick Filter:',
    ququ: 'Cross-region Active Areas',
    reUpload: 'Re-upload',
    realNameStatusLabel: 'Real-name Verification Status:',
    realNameStatusTable: 'Real-name Verification Status',
    reason: 'Reason',
    reasonLength5_100: 'Please enter 5–100 characters',
    recallConfirmTip: 'You have selected {n} leads. After recall, these leads will become unassigned and available for redistribution. Do you want to continue?',
    recallReminder: 'Recall Reminder',
    receive: 'Claim',
    receiveFailed: 'Claim failed',
    rechargePhoneBill: 'Recharge Phone Balance',
    recycleBin: 'Recycle Bin',
    recycleReason: 'Recycle Reason',
    recycleTime: 'Recycle Time',
    recycleTimeRange: 'Recycle Time Range:',
    registerTime: 'Registration Time',
    reject: 'Reject',
    rejectReasonLabel: 'Rejection Reason:',
    rejectReasonPlaceholder: 'If rejected, please enter a reason (within 50 characters). This will be sent to the student pending transfer',
    releaseConfirmTip: 'You have selected {n} leads. After release, you will no longer follow up on these leads. Do you want to continue?',
    remark: 'Remark',
    remarkFail: 'Failed to save remark',
    remarkSuccess: 'Remark saved successfully',
    renewService: 'Renew Service',
    renewalBtn: 'Renew',
    renewSuccess: 'Renewal successful',
    renqu: 'Current Verified Region',
    replace: 'Replace',
    reportLocalAgentId: 'Reported Master Franchisee ID',
    reportLocalAgentName: 'Reported Master Franchisee Name',
    requestFailed: 'Request failed',
    resendAfterSecondsShort: 'Resend in {n}s',
    restoreCluesTip: 'Notice',
    resultPreview: 'Result Preview',
    resultScoreFormatError: 'Invalid result score format',
    reviewTime: 'Review Time',
    reviewer: 'Reviewer',
    revokeApply: 'Revoke Application',
    revokeApplyFailed: 'Failed to revoke application',
    revokeApplySuccess: 'Application revoked successfully',
    ronglianOutcall: 'Ronglian Outbound',
    ru: 'Inbound',
    sale: 'Sales Rep',
    san: 'Grade 12',
    gaoyi: 'Grade 10',
    gaoer: 'Grade 11',
    gaosan: 'Grade 12',
    gaosi: 'Others',
    save: 'Save',
    saveAndPublishFail: 'Failed to save and publish',
    saveStudyScore: 'Save Study Score',
    scheduleTime: 'Scheduled Time',
        scheduleTimeLabel: 'Scheduled Time:',
    testConfirm: 'Test Confirmation',
    testConfirmTime: 'Test Confirmation Time',
    text40sp: 'Cancel',
    textt828: 'View Learning Plan Report',
    text93h4: 'Re-invitation successful',
    textpuet: 'Counter',
    inviteExperienceSuccess: 'Experience invitation successful',
    inviteExperience: 'Invite to Experience',
    customerList: 'Customer List',
    experienceCourse: 'Experience Course',
    experienceStartDate: 'Experience Start Date',
    selectCourseSubject: 'Select Course Subject',
    pleaseSelectCourseSubject: 'Please select course subject',
    pleaseSelectExperienceStatus: 'Please select experience status',
    pleaseSelectCourse: 'Please select course',
    school: 'School',
        schoolFormLabel: 'School:',
    schoolAddress: 'School Address',
    schoolAddressLabel: 'School Address:',
    schoolApplication: 'School Application',
    schoolArea: 'School Region',
    schoolDetailAddress: 'School Detailed Address',
    schoolId: 'Learning Center ID',
    schoolLabel: 'School:',
    schoolLabel2: 'School:',
    schoolLabelShort: 'School:',
    schoolName: 'Learning Center Name',
    schoolApplicationSchoolName: 'School Name',
    schoolNameTip: 'Please enter the full public school name. Do not use abbreviations',
    schoolScale: 'Student Enrollment Size',
    schoolStage: 'School Stage',
    schoolStageLabel: 'School Stage:',
    scoreFormatError: 'Invalid format. Enter up to 3 digits and 1 decimal place',
    scoreProgressRequired: 'Score progress is required',
    scoreProgressLabel: 'Score Progress',
    scoringRateLabel: 'Scoring Rate',
    search: 'Search Student:',
    searchByChargeNamePhone: 'Search by name or manager phone number',
    searchByCounterNo: 'Search by counter ID',
    searchCustomer: 'Search Customer:',
    searchSchool: 'Search School',
    searchStudent: 'Search Student',
    selectActualVisitTime: 'Select Visit Time',
    selectDate: 'Select Date',
    selectDateTime: 'Select Date & Time',
    selectPromisedVisitTime: 'Select Promised Visit Time',
    selectSchoolLabel: 'Select School:',
    selectStage: 'Select Stage',
    selectSuccess: 'Selection successful',
    selectedItems: 'Selected',
    sendVerifyCode: 'Send Verification Code',
    sendVerifyCodeSuccess: 'Verification code sent successfully',
    serviceAbnormal: 'Service error. Please try again later',
    serviceExpireTip: 'Current service {already} expired on {time}',
    costServiceActiveBefore: 'Current service will expire on',
    costServiceActiveAfter: '',
    costServiceExpiredBefore: 'Current service expired on',
    servicePerson: 'Service Person:',
    servicePersonLabel: 'Service Person:',
    servicePersonTable: 'Service Person',
    serviceTerminated: 'Service Terminated',
    serviceVersion: 'Service Version',
    sexLabel: 'Gender:',
    shortTermTempPass: 'Short-term Temporary Pass',
    shuxue: 'Math',
    sizeLimit: ', file size must not exceed 5MB',
    snCodeLabel: 'SN:',
    softwareActivateTime: 'Software Activation Time',
    softwareActiveStatus: 'Software Activation Status',
    sortPlaceholder: '1–98',
    source: 'Source:',
    sourceRequired: 'Source is required',
    stage: 'Stage',
    stageGrade: 'Stage/Grade',
    stageGradeLabel: 'Stage/Grade:',
    stageGradeLabel2: 'Stage/Grade:',
    stageGradeRequired: 'Stage and grade are required',
    stageGradeTable: 'Stage / Grade',
    startDate: 'Start Date',
    statsPeriod: 'Statistics Period:',
    statusColon: 'Status:',
    storageTime: 'Stock-in Time',
    storeRewardTier2MoreThanTier1: 'Tier 2 in-store reward must have more participants than Tier 1',
    storeRewardTier3MoreThanTier2: 'Tier 3 in-store reward must have more participants than Tier 2',
    storeRewardTier4MoreThanTier3: 'Tier 4 in-store reward amount must be greater than Tier 3',
    student: 'Student Account',
    studentAccount: 'Student Account',
    studentAccountLabel: 'Student Account:',
    studentAccountNotObtained: 'Student account not found',
    studentIdRequired: 'Student ID is required',
    studentInfo: 'Student Information',
    leadNameEditOnceTip: 'Lead name can only be edited once',
    nameEditUpToThreeTimesTip: 'Name can be edited up to three times',
    gradeEditOnceTip: 'Grade can only be edited once',
    studentIntroLength: 'Student introduction (50–2000 characters)',
    studentName: 'Student Name',
        studentNameFormLabel: 'Student Name:',
    studentNameLabel: 'Student Name:',
    studentNameLabelColon: 'Student Name:',
    studentNameOrPhone: 'Student Name/Phone:',
    studentNameRequired: 'Student name is required',
    studentStoryMin50Chars: 'Student story must be at least 50 characters',
    studentTransferApply: 'Student Transfer Application',
    subTagColumn: 'Sub-tag',
    subTagLabel: 'Sub-tag:',
    subTagNameRequired: 'Sub-tag name is required',
    subjectTotalPositiveInteger: 'Total subject score must be a positive integer',
    subjectTotalScorePositiveInteger: 'Total subject score must be a positive integer',
    submitAudit: 'Submit for Review',
    submitAuditFailed: 'Failed to submit for review',
    submitAuditSuccess: 'Submitted for review successfully',
    submitFailed: 'Submission failed',
    submitNow: 'Submit Now',
    submitSuccess: 'Submitted successfully',
    submit: 'Submit',
    subscriptionSubject: 'Subscribed Subject',
    success: 'Success',
    suochaxun: 'Lead Search',
    pleaseEnterClueNameOrMobile: 'Please enter lead name or phone number',
    supervisionFeeRequired: 'Instructor fee is required',
    supervisionFeeLabel: 'Instructor Fee',
    supervisionRenewConflict: 'Instructor renewal cannot be combined with new Learning Tablet or new Instructor service',
    supervisorConversionNum: 'Instructor Conversions',
    supervisorConversionRate: 'Instructor Conversion Rate',
    supervisorConversionRatio: 'Instructor Conversion Ratio',
    supervisorExpireTo: 'Instructor Valid Until',
    supervisorExpireToTable: 'Instructor Validity',
    supervisorStatusLabel: 'Instructor Status:',
    markSupervisorNoneDetailTip: 'After selecting no Instructor, the system will automatically remove the relationship between the student and the Analyst. You can view the student’s progress in the "Large Model Data Analysis System - Unsupervised Students" page',
    unsupervisedStudentDataTipDetail: 'You can view learning data for unsupervised students in the "Large Model Data Analysis System - Unsupervised Students" page',
    supervisorValidDateLabel: 'Instructor Validity:',
    supervisorExpireNextDayTip: 'The day after the Instructor service ends, the status will automatically change to "Expired"',
    supervisorStoreLabel: 'Instructor Learning Center:',
    pleaseSelectSupervisorStore: 'Please select Instructor Learning Center',
    remarkLabelWithColon: 'Remark:',
    syncCourseStatusLabel: 'Sync Course Status:',
    syncCourseStatusTable: 'Sync Course Status',
    tagCategoryLabel: 'Tag Category:',
    tagLabel: 'Tag:',
    tagLabelShort: 'Tag:',
    tagNameLabel: 'Tag Name:',
    taskStatusLabel: 'Task Status',
    tempPassHolding: 'Temporary Pass Active',
    tempPassTip: 'A temporary pass allows students who have not met performance requirements to continue sync course learning temporarily. Please issue with caution',
    tempPassTypeLabel: 'Temporary Pass Type:',
    templateBgColor: 'Template Background Color:',
    templateDelete: 'Delete Template',
    templateNameLabel: 'Activity Template Name:',
    templateNameSearchLabel: 'Template Name:',
    templateOffShelf: 'Unpublish Template',
    templatePublish: 'Publish Template',
    templateSaveSuccess: '{flag} successful',
    templateTip: 'Please download the latest template and do not modify or delete the first two rows',
    templateTypeLabel: 'Activity Template Type:',
    templateListTemplateTypeLabel: 'Template Type:',
    text0bq4: 'Improve',
    text0pmo: 'Search Parameters',
    text7041: 'Progress Score',
    texty59e: 'Enrollment Score',
    text0zrv: 'Leave blank',
    text126z: 'Retrieve Table Data',
    text14yy: 'Manufacturer Returns/Exchanges',
    text1609: 'Default',
    text16d6: 'Report Type',
    text1g8k: 'Stage List',
    text1h2y: 'Note',
    text1sge: 'Scan to view case details',
    scoreCaseCardTooltipViews: 'Views',
    scoreCaseCardTooltipCollects: 'Favorites',
    scoreCaseCardTooltipShares: 'Shares',
    scoreCaseCardTooltipCampusUse: 'Learning Center Usage',
    scoreCaseCardStudyDaysLabel: 'Study Days',
    scoreCaseCardDownloadPoster: 'Download poster to share',
    scoreCaseCardShareImageFileName: 'Case Sharing.png',
    scoreCaseCardTitleDaysImprove: '{days} Days Improvement',
    scoreCaseCardTagScoreGain: '+{score} Points',
    scoreCaseCardTagDaysSinceEnroll: '{days} Days Since Enrollment',
    scoreCaseCardScoreWithUnit: '{score} pts',
    text1tpq: 'Close Preview',
    text1uvl: 'Filter Value',
    text245v: 'Handle checkbox changes and update search parameters accordingly',
    text29q9: 'Optional',
    text2chn: 'Current results:',
    text2ffx: 'Select All',
    text2kky: 'Do not enter arbitrary values',
    text2m1b: 'Here',
    text2n18: 'Student Scores',
    text2oge: 'School Tag',
    text2u5x: 'After canceling',
    text2v8u: 'Total data length',
    text30tx: 'Server Type',
    text39fb: 'Please enter student story',
    text3l9l: 'Table operations',
    text3pnx: 'Squirrel Ai',
    text3qnn: 'Required field',
    text3uew: 'Sort',
    text3w27: 'Report Name',
    text41s1: 'Search Content',
    text429c: 'Form',
    text4a3g: 'Or changed search conditions',
    text47n0: 'Community Store',
    text4if3: 'Result Description',
    importDetailResultColumn: 'Import Status',
    clueImportResult0: 'Importing',
    clueImportResult1: 'Failed',
    clueImportResult2: 'Success',
    clueImportResult3: 'Success',
    text4l7a: 'Classic Cases',
    text4lpi: 'Number of Knowledge Points',
    text4r37: 'Course Type',
    text5bx8: 'Update',
    text5jly: 'Retrieve Subject List',
    text5pnc: 'Click to view supporter details',
    text5tye: 'Actual Learning Progress',
    text5x5t: 'Retrieve popular cases and update component state',
    text5xd7: 'Post-learning Score',
    text5xd9: 'Views',
    text5xnm: 'Table',
    text60d9: 'Study Days',
    text62uf: 'Learning Center Usage',
    text64ws: 'Select login type',
    text6d5o: 'Import Details',
    text6fpu: 'After publishing',
    text6wd3: 'Improvement Plan',
    text793f: 'Query error',
    text7b65: 'Task Cards',
    text7dyv: 'Toggle component closed state',
    text7k6h: 'Unsubscribe',
    text7t2x: 'Login Type',
    text7xij: 'Test Report',
    text7y5k: 'Receive',
    text80zn: 'Foundation Reset',
    text825h: 'Client Phone Type',
    text85vb: 'School Cases',
    text8ej2: 'Inviter',
    text8kwm: 'Please select stage first',
    text925t: 'Import Result',
    text95jx: 'Then',
    text9e60: 'Method',
    text9et6: 'Remove permission to publish improvement cases',
    text9g4w: 'Send',
    text9qrf: 'Edit Improvement Plan',
    text9y83: 'Supporter Details',
    texta8dx: 'More Options',
    textae2r: 'Export Current Details',
    textapni: 'Retrieve Form Data',
    textaru3: 'Determines final API parameter names',
    textawcc: 'Login Parameters',
    textbbau: 'Student Story',
    textbdya: 'WeChat Nickname',
    textbidw: 'Stage',
    textbkhp: 'Voted Student Name',
    textbseu: 'Traffic-driving Course Report',
    textc5y4: 'Improvement Effect',
    textch0r: 'Edit Study Score',
    textcjnr: 'Or manually clear and click search',
    textdci8: 'My Favorites',
    textdcsw: 'Improve',
    textdds7: 'Referred Student Name',
    textdffx: 'Do not enter arbitrary values',
    textdif5: 'System Message',
    textdqe9: 'Accuracy',
    textdrns: 'Please enter activity name',
    textds5q: 'Total data length',
    textdzp8: 'Learning Path',
    texte96r: 'Lead Rules',
    texteed4: 'Collapse Options',
    textefu3: 'Retrieve form data from public pool',
    texteklv: 'Case Display Information',
    textk19t: 'Please select a student and complete case information first',
    smallhour: 'Hour',
    share: 'Share',
    textekyu: 'Foundation Relearning',
    textelrk: 'Follow-up Person',
    texteltn: 'Search User',
    textf5t0: 'Middle School',
    textf9ue: 'New Version Tool',
    textfbrl: 'Please enter user',
    textfed3: 'Study Days',
    textfyvk: 'Views',
    textg8s8: 'Pre-learning Score',
    textgnlu: 'Adaptive Learning',
    textgvft: 'Progress Score',
    textgz5r: 'Invitee',
    texth2dc: 'Regular Course',
    texth39f: 'Source Management',
    texth5t6: 'Source',
    texthbj2: 'Please enter',
    texthco4: 'Retrieve search input data',
    texthjji: 'Please go to Pinecone',
    texthvm6: 'Foundation Upgrade',
    texthzx7: 'Total Data Volume',
    texti3md: 'Logged-in Skill Group',
    texti3uw: 'Default Sort',
    textibiy: 'Export Details',
    textidk9: 'Regular Course Relearning',
    textif9n: 'Execute Search',
    textiu8r: 'Close counter dialog',
    textiune: 'Already exists',
    textj8or: 'Form Data',
    textjw1n: 'Technology transforms education',
    textjw4y: 'Backup Phone Number',
    textl0ql: 'Phone Device',
    textljf2: 'Legacy Tool',
    textltlk: 'Enter Knowledge Space',
    textlzrj: 'Error Reason',
    textm00g: 'Regular Course Report',
    textm590: 'Student',
    textm7oq: 'Current Votes',
    textm9t5: 'High School',
    textmpf2: 'Published successfully',
    textmr1r: 'Export Image',
    textn2qz: 'Follow-up Status',
    textn4j7: 'Unpublished successfully',
    textn7no: 'Review',
    textnbt3: 'Form Data',
    textngy8: 'Student Name',
    textni8p: 'Manufacturer Returns/Exchanges',
    textnkpc: 'Enrollment',
    textno2h: 'Retrieve stage and subject dictionary list and update component state',
    textnyic: 'Close counter',
    texto188: 'Do not enter arbitrary values',
    texto9j5: 'Import Component',
    texto9pn: 'Optional field',
    textof4b: 'Update stage filter based on user selection',
    textoh9j: 'Update subject filter based on user selection',
    textoryg: 'Determines final API parameter names',
    textoz2b: 'Table Data',
    textozwa: 'Enrollment Score',
    textpd4r: 'Home Address',
    textpuh0: 'Course Learning Progress',
    textpzrd: 'Number of Classes',
    textqgox: 'Avatar',
    textqian: 'Unpublish',
    textqit9: 'Add page view tracking',
    textqjmj: 'Input',
    textqmvx: 'Add permission to publish improvement cases',
    textr0p8: 'Edit permission for improvement cases',
    textrgur: 'Table Title',
    textrhrk: 'Edit',
    textrixp: 'Monitor feature usage',
    textrsdh: 'Softphone',
    textrx7n: 'Publish this case?',
    textrxnr: 'Top navigation back function',
    texthkhr: 'Add Recommendation',
    texts0fj: 'Student Recommendation',
    texts6a0: 'Number of Learning Centers Used',
    textsauw: 'Used',
    textsbo6: 'Total Questions',
    textschc: 'Load failed',
    textsdmg: 'Set all to default',
    textsfjp: 'Top List (State)',
    textsgcw: 'Retrieve stage list',
    textsi66: 'Other',
    textsycd: 'Knowledge Space',
    textt3r7: 'Latest',
    textt612: 'Tag Management',
    textt6gm: 'Stage',
    texttghz: 'Switch Panel',
    texttxub: 'Otherwise, set all to default',
    textu1i9: 'Edit Student Story',
    textua16: 'Please select subject',
    textug0h: 'Unpublish this case?',
    textul9z: 'View report redirect',
    textuve4: 'Note',
    textvk04: 'Subject List',
    textvntq: 'Authentication details in request headers',
    textw94g: 'Please enter activity',
    textwaj4: 'Form Data',
    textwi6w: 'Page update',
    textwmyx: 'Lead Name',
    textwuf3: 'Please select a student and complete the case information first!',
    textx2bf: 'Trial Class Report',
    textx7ij: '{n} student score records',
    textxu12: 'Enable outbound call prediction',
    textxxuo: 'Click to clear',
    texty201: 'If applicable',
    texty6pb: 'Favorites',
    textyad6: 'Add New Case',
    textyiar: 'Referral Activity Details Export',
    textyl8q: 'Helper count dialog',
    textz099: 'Unsubscribe',
    textz9y4: 'National Top List',
    textzhl7: 'Leaderboard',
    textzlms: '{days}-day improvement',
    textzqig: 'Permission to publish improvement cases',
    textzy8y: 'Voting Users',
    time: 'Last Modified Time',
    titleBgPicLabel: 'Title Background Image:',
    to: 'To',
    experienceDateRangeMiddle: ' to ',
    todayClaimable: 'Claimable Today:',
    totalCost: 'Total Spending',
    totalDataCount: 'Total Data Volume',
    totalLeads: 'Total Leads',
    totalScoreLabel: 'Total Score',
    totalUnits: 'Total Units:',
    trainee: 'Student',
    transferApplySuccessTip: 'User {name} ({account}) has submitted a request to transfer to a Service Center. Please ask the parent to confirm in the Squirrel Ai Learning Tablet Parent App. If not confirmed within 7 days, the transfer will fail and must be resubmitted.',
    transferFailed: 'Transfer failed',
    transferLead: 'Transfer Lead',
    transferLeadTip: 'After transfer, the lead owner will be updated to the selected colleague. Please choose the staff account to transfer to.',
    selectStaff: 'Select Staff',
    pleaseSelectStaff: 'Please select staff',
    onlyNormalStaffCanTransfer: 'Only staff with "Active" status can be selected for transfer',
    transferShort: 'Transfer',
    transferToServiceCenter: 'Transfer to Service Center',
    trialStatusExperiencing: 'In Progress',
    trialStatusTerminated: 'Terminated',
    followUpToday: 'Follow-ups Today',
    followUpOverdue: 'Overdue Follow-ups',
    followUpCompleted: 'Completed',
    followUpCancelled: 'Cancelled',
    unknownOrderStatus: 'Unknown Order Status',
    unmarkPrototype: 'Unmark Demo Device',
    updateCountTip: 'Only updates to existing leads are counted',
    updateImport: 'Update Import',
    updateImportTip: 'You are updating data from the imported file "{fileName}". Any new leads in the file will also be imported.',
    updatedCount: 'Updated',
    uploadBeforeTip: 'Before uploading, please',
    uploadDoc: 'Upload Document',
    uploadFailed: 'Upload failed. Temporary token has expired. Please refresh and try again.',
    uploadImage: 'Upload Image:',
    uploadMaterial: 'Upload Materials',
    uploadStatusError: 'File upload status error',
    uploadSuccess: 'Upload successful',
    uploadTipSuffix: 'and enter leads according to the guidelines, otherwise import will fail',
    uploadVideo: 'Upload Video:',
    uploadVideoSize100MB: 'Video size must not exceed 100MB',
    uploadVoucherImage: 'Upload Voucher Image',
    uploadVoucherTip: 'Only JPG/PNG files allowed, up to 10MB each, maximum 6 files',
    uploading: 'Uploading...',
    useDeskPhoneOutcall: 'Use desk phone for outbound calls',
    usePhoneOutcall: 'Use mobile phone for outbound calls',
    userNameLabel: 'User Name:',
    userProfile: 'User Profile',
    userProfileLabel: 'User Profile:',
    validateFailed: 'Validation failed. Please try again later.',
    validityDaysUnit: '{days} days ({date})',
    validityEndLabel: 'Valid Until:',
    verifyCodeError: 'Invalid verification code',
    verifyCodeRequired: 'Verification code is required',
    verifyCodeSendSuccess: 'Verification code sent successfully',
    verifyFail: 'Verification failed',
    verifyPhoneRequired: 'Please verify the customer’s phone number before enabling the trial.',
    verifyPhoneTitle: 'Verify Phone Number',
    verifySuccess: 'Verification successful',
    video: 'Video',
    videoExceed20M: 'Video exceeds 20MB. Please compress and upload again.',
    videoExceed50M: 'Video exceeds 50MB. Please compress and upload again.',
    videoFormatMp4Avi: 'Only MP4/AVI formats are supported',
    videoFormatTip: 'Supports MP4/AVI, maximum file size 50MB',
    videoMaterial: 'Video Materials',
    videoSizeExceeded: 'Video size must not exceed 300MB',
    view: 'View',
    viewExamInfo: 'View Exam Information',
    viewFace: 'View Face Data',
    viewImage: 'View Image',
    viewInfo: 'View Information',
    viewProgress: 'View Progress',
    viewSchoolInfo: 'View School Information',
    visitStore: 'Visited Store:',
    visitStoreLabel: 'Visited Store:',
    visitTimeLabel: 'Visit Time:',
    week: 'Reporting Period:',
    weekPromiseVisitLabel: 'Promised Visits This Week:',
    thisWeekPromisedVisit: 'Promised Visits This Week',
    whitelist: 'Whitelist',
    withdrawSuccess: 'Withdrawn successfully',
    year: 'Grade Level',
    yes: 'Yes',
    yi: 'Normalized Report',
    yuanUnit: '$',
    zhanghuyouqi: 'Account Validity Period',
    commonGrade: 'General',
    taskStatusOverdue: 'Overdue',
    followUpNotStarted: 'Not Started',
    pendingFollowUp: 'Pending Follow-up',
    calledPhone: 'Called',
    addedWeChat: 'Added on WeChat',
    promisedVisit: 'Visit Promised',
    visited: 'Visited',
    dealDone: 'Deal Closed',
    myLeadsRule: 'My Leads Rules',
    autoRecycleMechanism: 'Auto-Recycle Mechanism',
    switchOn: 'On',
    switchOff: 'Off',
    autoRecycleTip: 'When enabled, leads that are not followed up or converted within a set number of days will be automatically reclaimed by the system.',
    daysNotFollowed: 'Days without follow-up',
    daysNotConverted: 'Days without conversion',
    pleaseEnterDays: 'Please enter number of days',
    leadPhoneDisplay: 'Lead Phone Visibility',
    leadPhoneDisplayTip: 'Selected users will be able to view and export full lead phone numbers in the system',
    publicPoolRule: 'Public Pool Rules',
    publicPoolSetting: 'Public Pool Settings',
    publicPoolEnableTip: 'When enabled, all sales staff can view the public pool and claim unassigned leads',
    publicPoolDisableTip: 'When disabled, sales staff cannot view the public pool and leads must be assigned by administrators',
    allocatedOver: 'After assignment, leads exceeding',
    autoRecycleDays: 'days will be automatically reclaimed by the system',
    intentionHigh: 'High',
    intentionMedium: 'Medium',
    intentionLow: 'Low',
    daysNotFollowedQuick: '7 days without follow-up',
    daysNotConvertedQuick: '30 days without conversion',
    smallClass: 'Small Class',
    middleClass: 'Medium Class',
    bigClass: 'Large Class',
    grade1: 'Grade 1',
    grade3: 'Grade 3',
    grade4: 'Grade 4',
    grade5: 'Grade 5',
    grade6: 'Grade 6',
    grade7: 'Grade 7',
    grade9: 'Grade 9',
    inviteKnowledgeGapExam: 'Invite to Knowledge Gap Assessment',
    inviteBy: 'Invited By',
    knowledgeGapBigExperience: 'Knowledge Gap Experience',
    inviteTime: 'Invitation Time',
    appointmentVisitTime: 'Scheduled Visit Time',
    visitStatus: 'Visit Status',
    visitTime: 'Visit Time',
    inviter: 'Follow-up Owner',
    experienceStatus: 'Experience Status',
    courseSubject: 'Course Subject',
    subject: 'Subject',
    testTime: 'Test Time',
    analystPersonColumn: 'Analyst',
    allLeadsTab: 'All Leads',
    allLeadsTabDesc: 'For managers to manage, assign, and review leads',
    myLeadsTab: 'My Leads',
    myLeadsTabDesc: 'For sales to manage and track leads',
    publicPoolTab: 'Public Pool for managing unassigned leads',
    recycleBinTab: 'Recycle Bin for managing invalid leads',
    pleaseEnterMobile: 'Please enter mobile number',
    source10: 'Source',
        sourceFormLabel: 'Source:',
    marker11: 'Marked By',
    intentLevel13: 'Intent Level',
    operationMode16: 'Operation Mode',
    markedInvalidReason26: 'Invalidation Reason',
    clueMgmt_ph_leadNameOrPhone: 'Enter lead name or phone number',
    clueMgmt_ph_selectThisWeekVisit: 'Select promised visits this week',
    clueMgmt_ph_selectCreator: 'Select creator',
    clueMgmt_ph_selectMarker: 'Select marker',
    clueMgmt_lastAssignTime: 'Last Assignment Time',
    clueMgmt_lastFollowPerson: 'Last Follow-up Owner',
    clueMgmt_lastFollowRecord: 'Last Follow-up Record',
    clueMgmt_invalidTime: 'Invalidation Time',
    clueMgmt_markInvalidTime: 'Invalidation Mark Time',
    clueMgmt_gradeOnly: 'Grade',
        gradeFormLabel: 'Grade:',
    clueMgmt_mobileNumber: 'Mobile Number',
    clueMgmt_nextFollowTime: 'Next Follow-up Time',
    followStatus: 'Follow-up Status',
    follower: 'Follow-up Owner',
        followerFormLabel: 'Follow-up Owner:',
    claimTime: 'Claim Time',
    homeworkDetail: 'Homework Details',
    enterActivity: 'Enter activity',
    enterActivityName: 'Enter activity name',
    enterPhone: 'Enter mobile number',
    inviterWxNickname: 'Inviter WeChat Nickname',
    inviterWxAvatar: 'Inviter Avatar',
    inviteeWxNickname: 'Invitee WeChat Nickname',
    inviteeWxAvatar: 'Invitee Avatar',
    inviteePhone: 'Invitee Mobile Number',
    inviteProgress: 'Invitation Progress',
    retentionTime: 'Retention Time',
    queryBtn: 'Search',
    resetBtn: 'Reset',
    auto_933: 'Presale Discount Price',
    auto_406934: 'Original Price $406',
    auto_935: '*Outbound calling technology provided by',
    auto_936: 'the same vendor as Zuoyebang and Yuanfudao',
    auto_937: '*Covers phone number resources from all three major carriers nationwide',
    auto_938: 'Nationwide carrier number resources',
    auto_939: '*System automatically assigns and displays local numbers,',
    auto_940: 'no need to prepare your own number resources',
    auto_941: 'avoids number flagging and blocking issues',
    auto_942: '*For new activation,',
    auto_943: 'a one-time technical setup fee is required; renewals will not be charged again',
    auto_944: '*Billed monthly,',
    auto_945: 'no limit on number of users',
    auto_946: 'Setup Fee:',
    auto_947: 'Limited-time 90% off, original price $288.00',
    auto_948: 'Package Fee:',
    auto_949: 'Unlimited users, includes 500 free minutes; $0.12/min thereafter',
    auto_950: 'Activation Duration (months):',
    auto_951: 'Presale supports up to 12 months',
    auto_954: 'Total:',
    auto_958: 'This payment will deduct:',
    auto_959: 'Please confirm whether to cancel the order. Once canceled, the payment will be refunded',
    auto_960: 'to the corresponding Master Franchisee account and the futures order quota will be adjusted accordingly!',
    auto_1003: 'Payment Settings',
    auto_1004: 'Auto-Renewal',
    auto_962: 'Auto-renewal is enabled. After expiration, the outbound calling service will automatically renew at $170/month, deducted from the cash account by default',
    auto_1005: 'Recharge Balance',
    auto_1006: 'Current Balance:',
    auto_1007: 'Recharge Amount:',
    auto_1008: 'Please enter a number',
    auto_964: '(Call rate: $0.12/min)',
    auto_1009: 'Amount Due:',
    auto_1011: 'Setup Fee:',
    auto_969: 'Limited-time 90% off',
    auto_970: '(Original price $288)',
    auto_973: '① After payment is completed, headquarters will complete business onboarding and service activation within',
    auto_974: '7–10 business days',
    auto_975: '. In some regions, activation may take longer due to limited number resources. Please check the status in Master Franchisee System - Outbound Call Center - Fee Management',
    auto_17976: '② To avoid disruption to your outbound operations, based on your selected duration, the service will automatically renew at $170/month upon expiration, deducted from your cash account by default,',
    auto_978: '③ Flexible usage,',
    auto_979: 'supports refunds',
    auto_1010: 'Activate Outbound Calling Service',
    auto_1012: 'Package Fee:',
    auto_971: '(Unlimited users, includes 500 free minutes; $0.12/min thereafter)',
    auto_1013: 'Activation Duration (months):',
    auto_1014: 'Total Payment:',
    auto_972: 'Auto-renew upon expiration',
    auto_17986: '① To avoid disruption to your outbound operations, based on your selected duration, the service will automatically renew at $170/month upon expiration, deducted from your cash account by default,',
    auto_977: 'Can be turned off anytime',
    auto_988: '③ Flexible usage, supports refunds',
    auto_952: 'Before payment, please read and agree to the',
    auto_953: 'Outbound Calling Service Agreement',
    auto_956: 'Pay',
    auto_993: 'Your outbound calling service is currently active. To avoid duplicate setup fees, please use',
    auto_994: 'Master Franchisee System - Outbound Call Center - Fee Management - "Renew"',
    auto_995: 'for renewal. If you have any questions, please contact Squirrel Ai Customer Support',
    auto_996: 'Your outbound calling service is currently being activated. It is expected to be completed within 7 business days after ordering. Please do not place duplicate orders. For questions, contact Squirrel Ai Customer Support',
    auto_998: 'You have not activated outbound calling service yet. Please use',
    auto_999: 'Master Franchisee System - Outbound Call Center - Fee Management - "Activate Service"',
    auto_1000: 'to complete activation and payment. For questions, contact Squirrel Ai Customer Support',
    auto_1001: 'Your outbound calling service is currently being activated. It is expected to be completed within 7 business days after ordering. Please do not renew again. For questions, contact Squirrel Ai Customer Support',
    auto_605: 'Service activation logic failed',
    auto_606: 'Payment successful',
    auto_607: 'Payment failed',
    auto_591: 'Mini Flyer',
    auto_592: 'Create Activity',
    auto_593: 'Daily Image',
    auto_594: 'View Full Image',
    auto_595: 'View Video',
    auto_806: 'Activity Operation Rules',
    auto_807: 'I have carefully read and understood all provisions of the Advertising Law and agree to comply strictly',
    auto_808: 'Advertising Law Usage Guidelines',
    auto_2809: '19941027199521',
    auto_24810: '20154',
    auto_811: 'General provisions',
    auto_812: 'Article 1',
    auto_813: 'Article 2',
    auto_814: 'Article 3',
    auto_815: 'Article 4',
    auto_816: 'Article 5',
    auto_817: 'Article 6',
    auto_818: 'Article 7',
    auto_819: 'advertising',
    auto_820: 'Article 8',
    auto_821: 'advertisingservice',
    auto_822: 'Items that must be disclosed by law in advertisements should be shown prominently and clearly.',
    auto_823: 'Article 9',
    auto_824: '1) Using or disguising use of PRC flags, anthem, emblem, military flag, military anthem, or military emblem.',
    auto_825: 'Content',
    auto_826: 'Content',
    auto_827: 'Content',
    auto_828: 'Content',
    auto_829: 'Private',
    auto_830: 'Content',
    auto_831: 'Content',
    auto_832: 'Content',
    auto_833: 'Content',
    auto_834: 'lawlaw',
    auto_835: 'Article 10',
    auto_836: 'Article 11',
    auto_837: 'advertising',
    auto_838: 'advertisingdata',
    auto_839: 'Article 12',
    auto_840: 'advertisinglaw',
    auto_841: 'advertising',
    auto_842: 'Article 13',
    auto_843: 'Advertisements must not disparage other operators, products, or services.',
    auto_844: 'Article 24',
    auto_845: '1) No guaranteed promises about admissions, exam pass rates, certificates, or training outcomes.',
    auto_846: 'Content',
    auto_847: 'Content',
    auto_848: 'Article 25',
    auto_849: 'Content',
    auto_850: 'Content',
    auto_851: 'Content',
    auto_852: 'Content',
    auto_853: 'Article 28',
    auto_854: 'service',
    auto_855: 'Content',
    auto_856: 'law',
    auto_857: 'service',
    auto_858: '5) Other cases that deceive or mislead consumers with false or confusing content.',
    auto_859: 'Article 33',
    auto_860: 'Article 38',
    auto_861: 'service',
    auto_862: 'advertisinglaw',
    auto_863: 'Article 39',
    auto_864: 'Article 40',
    auto_865: 'advertisingservice',
    auto_866: 'Content',
    auto_867: 'Article 44',
    auto_868: 'Content',
    auto_869: 'Legal liability',
    auto_870: 'Article 55',
    auto_871: 'advertising',
    auto_872: 'advertisinglaw',
    auto_873: 'lawadvertising',
    auto_874: 'advertisinglaw',
    auto_875: 'advertisingadvertising',
    auto_876: 'advertisingadvertisingadvertisingPublish',
    auto_877: 'law',
    auto_878: 'Article 56',
    auto_879: 'servicelawadvertising',
    auto_880: 'serviceadvertising',
    auto_881: 'Article 57',
    auto_882: 'Content',
    auto_883: 'advertisingadvertisingPublishadvertising',
    auto_884: 'Publishlawadvertising',
    auto_885: 'Chemistry',
    auto_886: 'lawPublish',
    auto_887: 'lawPublishadvertising',
    auto_888: 'lawadvertising',
    auto_889: 'law',
    auto_890: 'Article 58',
    auto_891: 'advertisingadvertisinglaw',
    auto_892: 'lawPublishadvertising',
    auto_893: 'lawadvertising',
    auto_894: 'lawPublishadvertising',
    auto_895: 'lawPublishadvertising',
    auto_896: 'lawPublishadvertising',
    auto_897: 'lawPublishadvertising',
    auto_898: 'lawPublish',
    auto_899: 'lawPublishadvertising',
    auto_900: 'lawPublish',
    auto_901: 'law',
    auto_902: 'lawlaw',
    auto_903: 'Primary schoolPrimary school',
    auto_904: 'lawPublish',
    auto_905: 'lawPublishadvertising',
    auto_906: 'Prohibited words',
    auto_907: 'Content',
    auto_908: 'Content',
    auto_909: 'Content',
    auto_910: 'NO1TOP',
    auto_911: 'Content',
    auto_912: 'Content',
    auto_913: 'Content',
    auto_914: 'XX',
    auto_915: 'Content',
    auto_916: 'Content',
    auto_917: 'Content',
    auto_918: '100',
    auto_919: 'Content',
    auto_920: 'Content',
    auto_921: 'Content',
    auto_922: 'Content',
    auto_923: 'Content',
    auto_924: 'XX',
    auto_925: 'time',
    auto_926: 'time',
    auto_597: 'Scan with WeChat to preview',
    auto_600: 'Short Video',
    auto_638: 'Score Improvement',
    auto_639: 'Total Subject Score',
    auto_640: 'Please enter a 3-digit positive integer',
    auto_641: 'Enrollment Score',
    auto_643: 'Final Score',
    auto_642: 'Format: up to 3 digits with 1 decimal place',
    auto_608: 'Add Student Story',
    auto_645: 'Edit Student Story',
    auto_646: 'It is recommended to describe the student’s enrollment background, learning status, and progress while using Squirrel Ai',
    auto_647: 'Upload Image',
    auto_609: 'Save Information',
    auto_610: 'Learning Progress',
    auto_611: 'Total Learning Time',
    auto_613: 'Total Days',
    auto_614: 'Total Problems Completed',
    auto_615: 'Foundation Learning Time',
    auto_617: 'Foundation Knowledge Points Mastered',
    auto_618: 'Growth Record',
    auto_619: 'Time',
    auto_620: 'Number of Knowledge Points Mastered',
    auto_621: 'Overall Mastery Level',
    auto_622: 'Monthly Learning Time',
    auto_623: 'Target Learning Time',
    auto_624: 'Improvement Plan',
    auto_625: 'Add Directory Information',
    auto_626: 'Edit Directory Information',
    auto_627: 'Directory Order',
    auto_628: 'Directory Name',
    auto_630: 'Created By',
    auto_631: 'Learning Path',
    auto_633: 'View Report',
    auto_634: 'Consult for Improvement Plan',
    auto_474: 'Final score must be greater than enrollment score',
    auto_477: 'Enabled successfully',
    auto_478: 'Invite to Knowledge Gap Assessment Today',
    auto_479: 'Go to Knowledge Gap Assessment >>',
    auto_480: 'Total Duration',
    auto_481: 'Hours',
    auto_482: 'Trigger charts such as scatter plots and pie charts',
    auto_483: 'Axis trigger',
    auto_484: 'Line indicator',
    auto_486: 'No indicator',
    auto_487: 'Monday',
    auto_488: 'Tuesday',
    auto_489: 'Report List',
    auto_490: 'Thursday',
    auto_491: 'Friday',
    auto_492: 'Saturday',
    auto_493: 'Sunday',
    auto_496: 'Closed successfully',
    auto_500: 'In Progress',
    auto_650: 'Case Settings',
    auto_666: 'From Struggling Student to Top Performer: +35 Points in 90 Days (Math)',
    auto_667: 'Subject',
    auto_520: 'After selecting the student’s learning period',
    auto_670: 'Enrollment Grade',
    auto_672: 'Student Mobile Number',
    auto_673: 'Learning Center Account',
    auto_674: 'Student Type',
    auto_675: 'Homeroom Teacher',
    auto_676: 'Owner',
    auto_677: 'Learning Center',
    auto_652: 'Sharing Settings',
    auto_678: 'Share Poster',
    auto_654: 'Please select a poster template',
    auto_679: 'Lead Info Settings',
    auto_655: 'Save as Draft',
    auto_656: 'Save and Publish',
    auto_683: 'Select Score',
    auto_657: 'Please select pre-learning score',
    auto_685: 'Exam Type',
    auto_686: 'Exam Date',
    auto_687: 'Score',
    auto_658: 'Add Score Record',
    auto_690: 'Please select subject',
    auto_692: 'Please select exam type',
    auto_694: 'Please select exam date',
    auto_695: 'Total Score',
    auto_696: 'Please enter total score',
    auto_698: 'Please enter score',
    auto_699: 'Class Rank',
    auto_700: 'Please enter class rank',
    auto_701: 'Grade Rank',
    auto_702: 'Please enter grade rank',
    auto_705: 'Test Paper Photo',
    auto_659: 'Improvement Course Plan',
    auto_707: 'Number of Sessions',
    auto_708: 'Please enter number of sessions',
    auto_660: 'sessions',
    auto_709: 'Class Frequency',
    auto_710: 'Please enter class frequency',
    auto_712: 'Weekly Foundation Learning Time',
    auto_713: 'Please enter weekly foundation learning time',
    auto_714: 'Select Poster Template',
    auto_521: 'Add New Case',
    auto_545: 'Top Student Challenge',
    auto_546: 'Edit Case',
    auto_560: 'User Details',
    auto_578: 'Select Student',
    auto_579: 'Enter student name or adaptive account',
    auto_561: 'Student Basic Information',
    auto_562: 'Student Name',
    auto_564: 'Region',
    auto_567: 'Service Center',
    auto_568: 'Case Basic Settings',
    auto_580: 'Case Title',
    auto_581: 'Subject',
    auto_582: 'Math',
    auto_583: 'English',
    auto_584: 'Chinese',
    auto_585: 'Physics',
    auto_586: 'Chemistry',
    auto_587: 'Biology',
    auto_588: 'Geography',
    auto_589: 'Science',
    auto_590: 'Learning Period',
    auto_569: 'Up to 180 days',
    auto_570: 'Please select stage',
    auto_571: 'Case Sharing Settings',
    auto_572: 'Private',
    auto_573: 'Public',
    auto_574: 'Coins',
    auto_575: '50% of the download fee will be credited to the Franchisee account, and the remaining 50% will go to the headquarters scholarship fund for activities',
    auto_576: 'Save and Preview Case',
    auto_577: 'Save and Exit',
    auto_435: 'Age',
    auto_436: 'School',
    auto_437: 'Elementary School',
    auto_444: 'Middle School',
    auto_448: 'High School',
    auto_469: 'Module Type: Learning Report',
    auto_359: 'Device SN Code',
    auto_354: 'Logistics Details',
    auto_362: 'Learning Tablet Account ID',
    auto_363: 'Learning Tablet Account',
    auto_366: 'Original Mobile Number',
    auto_367: 'Please enter original mobile number',
    auto_369: 'Please enter verification code',
    auto_263: 'Resend',
    auto_370: 'New Mobile Number',
    auto_371: 'Please enter new mobile number',
    auto_368: 'Verification Code',
    auto_375: 'Company Name',
    auto_358: 'Latest',
    auto_378: 'Learning Tablet Notes',
    auto_380: 'Please enter content',
    auto_266: 'Product Name',
    auto_270: 'Device Status',
    auto_271: 'Device Activation Time',
    auto_273: 'Shipping Date',
    auto_274: 'Courier Company',
    auto_275: 'Tracking Number',
    auto_276: 'Logistics Status',
    pleaseEnterExpressCompany: 'Please enter courier company',
    pleaseEnterExpressNo: 'Please enter tracking number',
    pleaseSelectLogisticsStatus: 'Please select logistics status',
    auto_277: 'Assigned Counter',
    auto_278: 'Counter Assignment Time',
    counterEquipmentSearchSnLabel: 'Device SN Code:',
    counterEquipmentSearchSnPlaceholder: 'Enter device SN code',
    counterEquipmentSearchProductNameLabel: 'Product Name',
    counterEquipmentSearchProductNamePlaceholder: 'Enter product name',
    counterEquipmentSearchCounterAssignTimeLabel: 'Counter Assignment Time',
    auto_280: 'Not Activated',
    auto_282: 'Frozen',
    auto_382: 'Counter Type',
    auto_383: 'Counter ID',
    auto_284: 'Pending Review',
    auto_385: 'Counter Manager',
    auto_386: 'Enter counter manager name',
    auto_387: 'Manager Phone Number',
    auto_388: 'Enter manager phone number',
    auto_389: 'Province/City',
    auto_390: 'Counter Address',
    auto_391: 'Please enter counter address',
    auto_392: 'Application Notes',
    auto_393: 'Please enter application notes',
    auto_394: 'Counter Photos',
    auto_381: 'Contract Agreement',
    auto_397: 'Confirmation Result',
    auto_398: 'Please select confirmation result',
    auto_400: 'Please enter remarks',
    auto_401: 'Add Agreement',
    auto_403: 'Please select file type',
    auto_287: 'File Type',
    auto_288: 'Signing Date',
    auto_291: 'Created Time',
    auto_292: 'Created By',
    auto_293: 'Last Modified Time',
    auto_295: 'Lease Agreement',
    auto_296: 'Supplementary Agreement',
    auto_297: 'Other Agreements',
    auto_298: 'Attachments',
    auto_755: 'Paused',
    auto_765: 'Number of Helpers',
    auto_766: 'Average Helpers per User',
    auto_767: 'Store Visits',
    auto_768: 'Helper-to-Visit Conversion Rate',
    auto_756: 'Download Poster',
    auto_772: 'Enter activity name',
    auto_775: 'Enter prize name',
    auto_757: 'Quantity',
    auto_776: 'Enter prize quantity',
    auto_758: 'Users with 2 helpers can receive an $888 experience gift pack. Each phone number can participate only once',
    auto_777: 'Enter cash amount',
    auto_759: 'Address for redeeming experience card (4 helpers required)',
    auto_778: 'Enter province/city/district, street, and address',
    auto_779: 'Enter contact number for participants',
    auto_761: 'Scan to claim rewards',
    auto_208: 'Mark as Invalid',
    auto_209: 'Data Migration',
    auto_210: 'How to get more examples',
    auto_230: 'Associated Master Franchisee',
    auto_231: 'Next Follow-up Time',
    auto_238: 'Enter student name',
    auto_242: 'Please select date of birth',
    auto_1244: 'Family Members',
    auto_251: 'Follow-up Type',
    auto_252: 'Please select follow-up type',
    auto_254: 'Please enter follow-up description',
    auto_255: 'Follow-up Evidence',
    auto_257: 'Select next follow-up time',
    auto_258: 'Invite to Assessment',
    auto_219: 'Customer phone number not verified',
    auto_220: 'Please verify the customer’s phone number before enabling the trial',
    auto_221: 'Send Verification Code',
    auto_222: 'Next',
    auto_223: 'Validity Period',
    auto_225: 'Copy',
    auto_211: 'Selected time must be later than the current time',
    auto_212: 'Please select stage/grade',
    auto_237: 'Others',
    auto_239: 'The imported template format is invalid',
    auto_414: 'SN Code',
    auto_415: 'Please enter SN code',
    auto_416: 'Franchisee',
    auto_418: 'Reported Activation Location',
    auto_419: 'Franchisee Location',
    auto_420: 'Reported By',
    auto_421: 'Reported Master Franchisee',
    auto_422: 'Reviewing Master Franchisee',
    auto_423: 'Upstream Master Franchisee',
    auto_424: 'Reporting Time',
    auto_425: 'Cross-region Type',
    auto_426: 'Software Activation Status',
    auto_427: 'Review Result',
    auto_428: 'Payment Voucher',
    auto_413: 'Upload up to 5 files (images or PDF)',
    auto_299: 'File',
    auto_429: 'Reporting Reason',
    auto_430: 'Please enter reporting reason',
    auto_300: 'Operation Time',
    auto_301: 'Operator',
    auto_302: 'Reporting Status',
    auto_305: 'No learning tablet found',
    auto_309: 'Edit Report',
    auto_310: 'Resubmit Report',
    auto_311: 'Saved successfully',
    auto_312: 'Activate Trial',
    auto_313: 'Only image formats are supported',
    auto_314: 'Failed to retrieve cross-region type and reporting information',
    auto_736: 'Activity Status',
    auto_737: 'Activity Complaint Records',
    auto_738: 'Number of Initiators',
    auto_739: 'Number of Participants',
    auto_740: 'Number of Leads Collected',
    auto_741: 'Number of Conversions',
    auto_745: 'Activity Time',
    auto_735: 'Activity Rules',
    auto_747: 'Activity Preview',
    auto_749: 'No.',
    auto_750: 'Complaint Reason',
    auto_751: 'Complaint Details',
    auto_753: 'Complaint Time',
    auto_722: 'Title',
    auto_723: 'Publish Status',
    auto_547: 'Unpublish',
    auto_548: 'Publish',
    auto_717: 'Ranked',
    auto_727: 'Case Name',
    auto_728: 'Published Learning Center ID',
    auto_729: 'Published Learning Center Name',
    auto_730: 'Ranking Type',
    auto_719: 'National Ranking',
    auto_720: 'Provincial Ranking',
    auto_731: 'Ranking Time',
    auto_721: 'Close Preview',
    auto_553: 'Published',
    auto_554: 'Unpublished',
    auto_555: 'Removed',
    auto_556: 'Not Submitted',
    auto_557: 'Approved',
    auto_558: 'Disabled',
    auto_330: 'Please select appointment time',
    auto_333: 'Phone Number',
    auto_334: 'Invitation Time',
    auto_336: 'Test Time',
    auto_338: 'Test Status',
    auto_342: 'Subject',
    auto_343: 'Version',
    auto_344: 'Test Duration',
    auto_345: 'Unit',
    auto_346: 'Knowledge Mastery Rate',
    auto_279: 'Each Learning Center Master Franchisee can apply for data migration only once, and the target system must belong to the same franchise system',
    auto_285: 'Technical staff will complete the migration within 3 business days. Please wait patiently',
    auto_194: 'Connection URL',
    auto_195: 'Enterprise ID',
    auto_196: 'SIP Mode',
    auto_203: 'Login',
    auto_204: 'Logout',
    auto_0197: 'Mobile',
    auto_1198: 'SIP Phone',
    auto_2199: 'WebRTC Softphone',
    auto_200: 'Login Method',
    auto_201: 'Leave the skill group field empty after login',
    auto_1202: 'Default',
    auto_207: 'Monitoring feature usage (e.g., 103csqy)',
    auto_782: 'Back to Add Recommendation',
    auto_803: 'Participant Video',
    auto_4790: 'Video format: MP4',
    auto_791: 'Video duration: 15–60 seconds',
    auto_792: 'Video size must be within 100MB',
    auto_804: 'Handwritten Essay',
    auto_793: 'Preview',
    auto_794: 'Participant Details',
    auto_795: 'Preview after selecting student',
    auto_796: 'Preview after uploading video',
    auto_797: 'My Story with Squirrel Ai',
    auto_798: 'Preview after uploading handwritten essay',
    auto_800: 'Current information is not saved. Leave without saving?',
    auto_1021: 'Add Directory',
    auto_1027: 'Actions',
    auto_1028: 'Category Name',
    auto_1029: 'Enter category name',
    auto_1030: 'Directory Order',
    auto_1031: 'Privacy Settings',
    auto_1033: 'Enter category details',
    auto_1026: 'Create Now',
    auto_632: 'Number of Materials',
    auto_635: 'Are you sure you want to delete this category?',
    auto_501: 'Remaining trial quota this month:',
    auto_502: 'More Options',
    auto_503: 'Re-invite',
    auto_504: 'Confirm Trial',
    auto_506: 'Activate Entry Account',
    auto_529: 'Please select trial analyst',
    auto_511: 'Confirm that this user has completed the trial?',
    auto_513: 'Cancel this user’s trial?',
    auto_534: 'Activity Template',
    auto_535: 'Image Name',
    auto_539: 'Please select sub-tag',
    auto_20531: 'Supports JPG/PNG format. Recommended size 1080x1920. File size must not exceed limit',
    auto_351: 'Reason Name',
    auto_352: 'Please enter invalidation reason name',
    auto_248: 'Operation successful',
    auto_253: 'Edit Invalidation Reason',
    auto_1039: 'Status',
    auto_1038: 'Tag Name',
    auto_1042: 'Please enter tag name',
    auto_260: 'Edit Tag',
    auto_261: 'Please enter updated tag name',
    auto_318: 'Type',
    auto_317: 'Source Name',
    auto_322: 'Please enter source name',
    auto_241: 'Add Source',
    auto_245: 'Edit Source',
    auto_246: 'Please enter updated source name',
    auto_1043: 'Inviter A WeChat Nickname',
    auto_1044: 'Inviter A Avatar',
    auto_1045: 'Invitee B WeChat Nickname',
    auto_1046: 'Invitee B Avatar',
    auto_1047: 'Invitee B Phone Number',
    auto_1048: 'Invitation Progress',
    auto_1049: 'Invitation Time',
    auto_1050: 'Lead Capture Time',
    auto_1059: 'Service Center Name',
    auto_1060: 'Detailed Address',
    auto_1061: 'Brief Introduction',
    auto_1062: 'Brief introduction (50–500 words)',
    auto_1063: 'Introduction Images',
    auto_1064: 'Contact Person',
    auto_1065: 'Contact Information',
    auto_1066: 'Contact QR Code',
    auto_505: 'points or above',
    auto_1084: 'sessions/week',
    auto_1085: 'Squirrel Ai Adaptive Learning — Technology Transforms Education',
    auto_512: 'Foundation Downgrade',
    auto_515: 'Foundation Upgrade',
    auto_516: 'Foundation Relearning',
    auto_1052: 'Review Status',
    auto_1053: 'Vote ID',
    auto_1054: 'Current Ranking',
    auto_1056: 'Rejection Reason',
    auto_1051: 'Confirm withdrawal of review?',
    auto_1072: 'Import completed. Click to view',
    auto_1073: 'Import Query',
    auto_1074: 'Download data again and re-upload',
    potentialImportCompleteTip: 'Import completed. Click to view',
    potentialImportQueryLink: 'Import Query',
    potentialImportReuploadBtn: 'Download data again and re-upload',
    potentialImportRunningTip: 'Data import in progress. If the page is closed accidentally, you can check the status in "Import Query"',
    potentialImportFailureTip: 'Some data failed to import due to a server interruption. Please download and re-upload',
    auto_1088: 'Activate Account',
    auto_1067: 'Operation Reminder',
    auto_1068: 'Once marked as invalid, the lead will be recorded as invalid data and removed from the lead list. Continue?',
    auto_1070: 'Invalidation Reason',
    auto_1071: 'Within 100 characters',
    auto_325: 'Information not found',
    auto_326: 'Issuance failed',
    auto_327: 'Unable to issue pass',
    auto_329: 'System error',
    auto_470: 'Publish this case?',
    auto_471: 'Unpublish this case?',
    auto_472: 'Published successfully',
    auto_473: 'Unpublished successfully',
    auto_1075: 'Gift Package Claim Status',
    auto_1089: 'Outbound Calling Presale Offer',
    auto_1082: 'Copy Link',
    auto_1083: 'Download QR Code',
    craaViewDetail: 'View Details',
    craaResubmit: 'Resubmit',
    craaQueryFailed: 'Query failed',
    craaOnlyRejectedCanResubmit: 'Only rejected appeals can be resubmitted',
    craaAlreadyReportedNoNeedSubmit: 'This device has already been reported. No need to submit again',
    craaPendingReviewNoRepeatSubmit: 'This device already has a pending review. No need to resubmit',
    craaInObservationNoRepeatSubmit: 'This device is currently under observation. No need to resubmit',
    craaNoNeedSubmit: 'No submission required for this device',
    craaCheckResubmitStatusFailed: 'Failed to validate resubmission status',
    craaAppealStatus: 'Appeal Status',
    craaPleaseSelectAppealStatus: 'Please select appeal status',
    craaReviewApproved: 'Approved',
    craaReviewRejected: 'Rejected',
    craaAppealTime: 'Appeal Time',
    craaPleaseSelectAppealSubmitTime: 'Please select appeal submission time',
    craaSoftwareActivationTime: 'Software Activation Time',
    craaSoftwareActivationProvinceCity: 'Software Activation Location (State/City)',
    craaCrossRegionActiveDate: 'Cross-region Activity Date',
    craaCrossRegionActiveProvinceCity: 'Cross-region Activity Location (State/City)',
    craaReviewAgentId: 'Reviewing Master Franchisee ID',
    craaReviewAgentName: 'Reviewing Master Franchisee Name',
    craaReviewAgentContact: 'Reviewing Master Franchisee Contact',
    craaSubmitter: 'Submitted By',
    craaAppealSubmitTime: 'Appeal Submission Time',
    craaReviewTime: 'Review Time',
    craaReviewer: 'Reviewer',
    craaAppealDetailTitle: 'Cross-region Active Device Reporting Details',
    craaLearningMachineSnCode: 'Learning Tablet SN Code',
    craaSubmitterContact: 'Submitter Contact',
    craaSituationDescription: 'Situation Description',
    craaPurchaseProof: 'Purchase Proof',
    craaReviewRemark: 'Review Remarks',
    craaAppealRecordIdRequired: 'Appeal record ID is required',
    craaFetchAppealDetailFailed: 'Failed to retrieve appeal details',
    craaReportTitle: 'Cross-region Active Device Reporting',
    craaSubmitterContactPlaceholder: 'Phone number or WeChat ID for follow-up if the reviewer has questions',
    craaSubmitterContactInputPlaceholder: 'Enter phone number or WeChat ID',
    craaSubmitterContactHelper: 'You can provide a phone number or WeChat ID so the reviewer can contact you if needed',
    craaSubmitterContactLengthRule: 'Submitter contact must be 5 to 20 characters',
    craaPleaseEnterSituationDescription: 'Please enter a 5–100 word description',
    craaUploadTip: 'Please upload purchase proof and communication records with parents',
    craaPleaseEnterSituationDescriptionShort: 'Please enter situation description',
    craaSituationDescriptionLengthRule: 'Situation description must be 5–100 characters',
    craaPleaseUploadPurchaseProof: 'Please upload purchase proof',
    craaPurchaseProofUploadLimit: 'You can upload up to 9 images for purchase proof',
    craaOnlyImageFormatsAllowed: 'Only JPG, JPEG, PNG, and BMP formats are supported',
    craaImageSizeLimit: 'Image size must not exceed 20MB',
    craaUploadFailed: 'Upload failed',
    craaImageUploadingWait: 'Images are uploading. Please wait before submitting',
    craaResubmitSuccess: 'Resubmitted successfully',
    craaResubmitFailed: 'Resubmission failed',
    craaAddReport: '+ Add Report',
    craaOnlyBufferOrLockedCanSubmit: 'Only buffered or locked records can be submitted for review',
    craaResolveCrossRegionActiveProvinceCityFailed: 'Failed to resolve the cross-region activity location. Please refresh and try again',
    craaPleaseSelectStatus: 'Please select status',
    craaStatusNormal: 'Normal',
    craaStatusObservation: 'Under Observation',
    craaStatusLocked: 'Locked',
    craaSoftwareActivationDate: 'Software Activation Date',
    craaPleaseSelectSoftwareActivationDateRange: 'Please select software activation date range',
    craaLockDate: 'Device Lock Date',
    craaPleaseSelectLockDateRange: 'Please select lock date range',
    craaPleaseSelectDateRange: 'Please select date range',
    craaDataSource: 'Data Source',
    craaObservationEndDate: 'Observation End Date',
    craaPleaseSelectCrossCityActiveArea: 'Please select cross-city activity location',
    craaGetDealerInfoFailed: 'Failed to retrieve Master Franchisee information',
    craaPleaseEnterLearningMachineSnCode: 'Please enter Learning Tablet SN code',
    craaLearningMachineSnCodeLengthRule: 'Learning Tablet SN code must be within 100 characters',
    craaPleaseSelectCrossRegionActiveProvinceCity: 'Please select cross-region activity province/city',
    craaGetProvinceCityDataFailed: 'Failed to retrieve state/city data',
    craaAddReportSuccess: 'Report added successfully',
    craaAddReportFailed: 'Failed to add report',
    bphMarkBackupPhone: 'Mark Backup Device',
    bphBackupPhoneAvailableQuota: 'Available backup device quota:',
    bphQuotaHelpTip: 'Backup device quota equals 20% of last month’s active students for the Franchisee',
    bphGetQuotaFailed: 'Failed to retrieve backup device quota',
    bphQueryListFailed: 'Failed to retrieve backup device list',
    bphNoQuotaNow: 'No backup device quota available for the current Franchisee',
    bphPleaseEnterDeviceSnCode: 'Please enter device SN code',
    bphMarkTime: 'Mark Time',
    bphPleaseSelectMarkTimeRange: 'Please select mark time range',
    bphDeviceModel: 'Device Model',
    bphDealerId: 'Franchisee ID',
    bphDealerName: 'Franchisee Name',
    bphLocation: 'Location',
    bphDeviceHardwareStatus: 'Device Hardware Status',
    bphHardwareActivationDate: 'Hardware Activation Date',
    bphMarkBackupPhoneDate: 'Backup Device Mark Date',
    bphDeviceSnCodeWithColon: 'Device SN Code:',
    bphDealerIdWithColon: 'Franchisee ID:',
    bphDealerNameWithColon: 'Franchisee Name:',
    bphDeviceSnCodeLengthRule: 'Device SN code must be within 100 characters',
    bphDeviceSnChecking: 'Checking device SN...',
    bphDeviceSnCheckPassed: 'Device SN verified',
    bphDeviceSnCheckFailed: 'Device SN verification failed',
    bphPleaseFinishDeviceSnCheckFirst: 'Please complete device SN verification first',
    bphConfirmMarkDialogTitle: 'Confirm Mark',
    bphConfirmMarkDialogContent: 'After marking, the device will revert to an unactivated software state and cannot be activated again. This action cannot be undone. Confirm marking as backup device?',
    bphMarkBackupPhoneSuccess: 'Backup device marked successfully',
    bphMarkBackupPhoneFailed: 'Failed to mark backup device',
    improveCaseStatus: 'Case Status',
    pleaseSelectImproveCaseStatus: 'Please select case status',
    instanceMigration_belongCampus: 'Associated Learning Center',
    instanceMigration_selectBelongCampus: 'Please select associated Learning Center',
    instanceMigration_updateTimeColumn: 'Last Updated Time',
    instanceMigration_enterCaseNamePlaceholder: 'Please enter case name',
    instanceMigration_selectEnrollmentScore: 'Please select enrollment score',
    instanceMigration_selectProgressScore: 'Please select improvement score',
    instanceMigration_enterStudentAccount: 'Please enter student account',
    studentWithColon: 'Student:',
    pleaseEnterNameOrAccount: 'Please enter name or account',
    progressScoreRange5To10: '5–10',
    progressScoreRangeAbove10: 'Above 10',
    progressScoreRangeAbove20: 'Above 20',
    progressScoreRangeAbove30: 'Above 30',
    enrolScoreRangeBelow40: 'Below 40',
    enrolScoreRange41To60: '41–60',
    enrolScoreRange61To80: '61–80',
    enrolScoreRangeAbove81: '81 and above',
    viewStudentHomework: 'View Student Homework',
    practiceReport: 'Practice Report',
    answerRecord: 'Answer Record',
    followContent: 'Follow-up Content',
    enterFollowContent: 'Please enter follow-up content',
    uploadJpgPngLimit500k: 'Upload JPG/PNG files, max 500KB',
    appointmentTime: 'Appointment Time',
    selectAppointmentDate: 'Please select appointment date',
    enterRemark: 'Please enter remark',
    analyst: 'Analyst',
    selectAnalyst: 'Please select Analyst',
    inviteKnowledgeExam: 'Knowledge Gap Assessment Invited Successfully',
    inviteKnowledgeExam2: 'Knowledge Gap Assessment',
    inviteKnowledgeExamTime: 'Knowledge Gap Assessment Time',
    account: 'Account',
    homeworkName: 'Homework Name',
    dingtalkUsername: 'DingTalk Username',
    nextFollow: 'Next Follow-up',
    uploadImageFormat: 'Please upload JPG/PNG images',
    grade10: 'Grade 10',
    grade11: 'Grade 11',
    grade12: 'Grade 12',
    grade13: 'Repeat Year',
    general170: 'Primary to Middle School Transition',
    general175: 'Middle to High School Transition',
    general180: 'College Entrance Exam',
    export: 'Export',
    textfpck: 'View Study Plan Report',
    textybol: 'View Report',
    textata5: 'Confirm',
    textctp8: 'Confirm',
    textve0v: 'Upload Attachment',
    text1eqj: 'Copy and Import',
    textg7yv: 'Copy Link',
    textqtuz: 'Download Template',
    textraz2: 'Export All',
    text0yuv: 'Select Login Type:',
    texti3fa: 'Login Type:',
    textl78x: 'Predictive Outbound Calling:',
    textuztd: 'Client Phone Type:',
    text5gyv: 'Server Type:',
    ruleSettingAddTag: 'Add Tag',
    ruleSettingAddSource: 'Add Source',
    ruleSettingAddExpireReason: 'Add Invalidation Reason',
    expireReasonEditDialogTips: 'Please enter the name of the invalidation reason to modify',
    expireReasonMaxDiyTip: 'You can add up to {maxDiy} custom invalidation reasons',
    activityGalleryPictureNameLabel: 'Image Name:',
    activityGalleryPictureNamePlaceholder: 'Please enter template name',
    activityGalleryTemplateTypesLabel: 'Template Type:',
    activityGalleryTemplateTypesPlaceholder: 'Please select template type',
    activityGalleryTagLabel: 'Tag:',
    activityGalleryTagTypePlaceholder: 'Tag Type',
    activityGalleryTagIdsPlaceholder: 'Tag',
    activityGalleryAddTemplateButton: 'Add Activity Template',
    activityGalleryDeleteImageButton: 'Delete Image',
    webCall1: 'WebCall',
    webRtc2: 'WebRTC',
    ccs1: 'CCS',
    cti2: 'CTI',
    prototypeMarkWarning: 'Once a Learning Tablet is marked as a Demo Device, it cannot be modified',
    accountLabel: 'Account',
    activated: 'Activated',
    addTemplate: 'Add',
    addedWeChatOption: 'WeChat Added',
    addedWeChatStatus: 'WeChat Added',
    analystPersonLabel: 'Analyst',
    auto_1015: 'Activate Outbound Calling Service',
    auto_1016: 'Package Fee:',
    auto_1017: 'Activation Duration (Months):',
    auto_1018: 'Total Payment:',
    auto_1040: 'Operation',
    auto_1041: 'Tag Name',
    auto_1055: 'Operation',
    auto_1076: 'Operation',
    auto_1204: 'Default',
    auto_205: 'Login',
    auto_206: 'Logout',
    auto_224: 'Account',
    auto_2246: 'Family Members',
    auto_227: 'Copy',
    auto_249: 'Operation Successful',
    auto_250: 'Add Follow-up Record',
    auto_256: 'Next Follow-up Time',
    auto_259: 'Operation Successful',
    auto_262: 'Send Verification Code',
    auto_264: 'Send Verification Code',
    auto_265: 'Resend',
    auto_267: 'Master Franchisee',
    auto_268: 'Master Franchisee Name',
    auto_269: 'Account Status',
    auto_272: 'Account Activation Time',
    auto_281: 'Activated',
    auto_283: 'Subscribed',
    auto_289: 'Validity Period',
    auto_290: 'Data Migration',
    auto_294: 'Pending Review',
    auto_303: 'Account',
    auto_304: 'Copy',
    auto_306: 'Copy',
    auto_307: 'No Learning Tablet found',
    auto_308: 'Add Report',
    auto_319: 'Status',
    auto_320: 'Operation',
    auto_321: 'Source Name',
    auto_331: 'Selected time must be later than the current time',
    auto_335: 'Account',
    auto_347: 'Test Time',
    auto_348: 'Type',
    auto_349: 'Status',
    auto_350: 'Operation',
    auto_353: 'Change Mobile Number',
    auto_356: 'Next',
    auto_360: 'Operation',
    auto_361: 'Change Account Phone Number',
    auto_364: 'Master Franchisee ID',
    auto_365: 'Master Franchisee Name',
    auto_372: 'Verification Code',
    auto_373: 'Please enter verification code',
    auto_374: 'Logistics Details',
    auto_377: 'Tracking Number',
    auto_384: 'Status',
    auto_395: 'Attachment',
    auto_396: 'Operation',
    auto_399: 'Confirmation Remark',
    auto_402: 'File Type',
    auto_404: 'Lease Agreement',
    auto_405: 'Supplementary Agreement',
    auto_406: 'Other Agreement',
    auto_407: 'Signing Time',
    auto_409: 'Validity Period',
    auto_410: 'Attachment',
    auto_412: 'Please enter remark',
    auto_417: 'Status',
    auto_432: 'Mobile Number',
    auto_452: 'Elementary School',
    auto_459: 'Middle School',
    auto_464: 'High School',
    auto_468: 'Other',
    auto_485: 'Operation',
    auto_494: 'Hours',
    auto_495: 'Enabled successfully',
    auto_497: 'Enabled successfully',
    auto_498: 'Disabled successfully',
    auto_499: 'Enabled successfully',
    auto_507: 'Copy',
    auto_508: 'Copy',
    auto_514: 'Operation',
    auto_522: 'Elementary School',
    auto_530: 'Middle School',
    auto_536: 'High School',
    auto_540: 'Other',
    auto_542: 'Mobile Number',
    auto_549: 'Unpublish',
    auto_550: 'Publish',
    auto_559: 'Pending Review',
    auto_596: 'Flyer',
    auto_598: 'Flyer',
    auto_599: 'Daily Image',
    auto_601: 'Daily Image',
    auto_602: 'Short Video',
    auto_603: 'Enabled successfully',
    auto_604: 'Disabled successfully',
    auto_616: 'Hours',
    auto_629: 'Created Time',
    auto_636: 'Hours',
    auto_644: 'Format: up to 3 digits with 1 decimal place',
    auto_648: 'Payment successful',
    auto_649: 'Select Student',
    auto_651: 'Student Basic Information',
    auto_653: 'Top Student Challenge',
    auto_661: 'Sessions per week',
    auto_662: 'Hours',
    auto_663: 'Top Student Challenge',
    auto_665: 'Case Title',
    auto_669: 'Study Duration',
    auto_671: 'Student Name',
    auto_680: 'Mobile Number',
    auto_688: 'Add Score Record',
    auto_689: 'Subject',
    auto_691: 'Exam Type',
    auto_693: 'Exam Date',
    auto_697: 'Score',
    auto_706: 'Improvement Plan',
    auto_711: 'Please enter class frequency',
    auto_724: 'Review Status',
    auto_725: 'Operation',
    auto_726: 'Featured',
    auto_732: 'Download QR Code',
    auto_733: 'Activity ID',
    auto_734: 'Activity Name',
    auto_742: 'Operation',
    auto_743: 'Activity Rules',
    auto_744: 'Activity Name',
    auto_746: 'Activity Rules',
    auto_748: 'Activity Complaint Records',
    auto_752: 'Contact Information',
    auto_754: 'Download QR Code',
    auto_760: 'Contact Information',
    auto_762: 'Activity Rules',
    auto_763: 'Activity Status',
    auto_764: 'Number of Participants',
    auto_769: 'Operation',
    auto_770: 'Create Activity',
    auto_771: 'Activity Name',
    auto_773: 'Activity Time',
    auto_774: 'Activity Rules',
    auto_780: 'Download QR Code',
    auto_781: 'Download Poster',
    auto_783: 'Student Basic Information',
    auto_784: 'Student Name',
    auto_786: 'Region',
    auto_789: 'Learning Center',
    auto_801: 'Select Student',
    auto_802: 'Please enter student name or adaptive account',
    auto_929: 'Create Activity',
    auto_932: 'Outbound Calling Presale Offer',
    auto_965: 'Please read and agree to the outbound calling service',
    auto_966: 'Activation Agreement',
    auto_968: 'Pay',
    auto_980: 'Please read and agree to the outbound calling service',
    auto_981: 'Activation Agreement',
    auto_983: 'Pay',
    auto_984: '(Unlimited users, includes 500 free minutes; $0.12/min thereafter)',
    auto_985: 'Auto-renew upon expiration',
    auto_987: 'Can be turned off anytime',
    auto_989: 'Please read and agree to the outbound calling service',
    auto_990: 'Activation Agreement',
    auto_992: 'Pay',
    batchAllocationTitle: 'Batch Assignment',
    batchAssignAnalystTitle: 'Batch Assign Analyst',
    batchRecallAction: 'Batch Recall',
    batchRecover: 'Batch Recall',
    batchReleaseAction: 'Batch Release',
    batchRestoreAction: 'Batch Restore',
    bphDeviceSnCode: 'Device SN Code',
    calledPhoneOption: 'Called',
    calledPhoneStatus: 'Called',
    cancelPublishSuccess: 'Unpublished successfully',
    caozuo: 'Operation',
    categoryName: 'Category Name',
    chargePhone: 'Manager Phone Number',
    chuandan: 'Flyer',
    chuangjian: 'Created By',
    ci: 'Re-invite',
    commonGradeOption: 'General',
    contactLabel: 'Contact Person',
    copy: 'Copy',
    copyLinkLabel: 'Copy Link',
    costServiceExpiredAfter: 'Expired',
    counterAddress: 'Counter Address',
    counterAgentId: 'Master Franchisee ID',
    counterAgentLabel: 'Master Franchisee',
    counterAgentName: 'Master Franchisee Name',
    counterChargePerson: 'Counter Manager',
    counterEquipmentSearchAgentLabel: 'Master Franchisee',
    counterNo: 'Counter ID',
    counterType: 'Counter Type',
    craaDealerId: 'Franchisee ID',
    craaDealerLocation: 'Franchisee Location',
    craaDealerName: 'Franchisee Name',
    craaDeviceModel: 'Device Model',
    craaDeviceSnCode: 'Device SN Code',
    craaOperation: 'Operation',
    craaPendingReview: 'Pending Review',
    craaPleaseEnterDeviceSnCode: 'Please enter device SN code',
    craaStatus: 'Status',
    craaStatusPendingReview: 'Pending Review',
    createNow: 'Create Now',
    createTime: 'Created At',
    customerName2: 'Customer Name',
    customerNameColumn: 'Customer Name',
    customerNameLabelShort: 'Customer Name',
    customerPhoneLabel: 'Customer Mobile Number',
    dailyImage: 'Daily Image',
    danhao: 'Tracking Number',
    dataMigration: 'Data Migration',
    dealDoneOption: 'Closed Deal',
    dealDoneStatus: 'Closed Deal',
    dealerLocation: 'Franchisee Location',
    deleteMarker: 'Delete',
    detailAddress: 'Detailed Address',
    device: 'Device Model',
    dili: 'Geography',
    dispatchDate: 'Dispatch Date',
    downloadQrCode: 'Download QR Code',
    editTemplate: 'Edit',
    entryAccountCustomerNameOrPhone: 'Customer Name / Mobile Number',
    entryAccountPleaseSelectStatus: 'Please select status',
    entryCustomerNameLabel: 'Customer Name',
    entryExperienceDateLabel: 'Experience Date',
    experienceDate: 'Experience Date',
    experienceEndDate: 'Experience End Date',
    followPersonColumnLabel: 'Follow-up Person',
    followPersonLabel: 'Follow-up Person:',
    followPersonShort: 'Follow-up Person',
    followStatusColumn: 'Follow-up Status',
    followStatusColumnLabel: 'Follow-up Status',
    followStatusShort: 'Follow-up Status',
    followUp: 'Follow-up',
    followUpTodayQuick: 'Due Today',
    followVoucher: 'Follow-up Proof',
    grade2: 'Grade 2',
    grade8: 'Grade 8',
    gradeLabelColon: 'Grade:',
    gradeText: 'Grade',
    grantFail: 'Issuance failed',
    grantPassTitle: 'Issue Pass',
    hao: 'Activate Starter Account',
    hourlong: 'Weekly Foundation Study Time',
    importQuery: 'Import Query',
    infoNotExist: 'Information not found',
    intentLevel17: 'Intent Level',
    intentLevelLabelColon: 'Intent Level:',
    intentLevelText: 'Intent Level',
    invalidReason: 'Invalidation Reason',
    invalidReason12: 'Invalidation Reason',
    invitationTime: 'Invitation Time',
    inviteBigExam: 'Knowledge Gap Assessment',
    inviteByLegacy: 'Invited By',
    inviteKnowledgeVulnExam: 'Knowledge Gap Assessment',
    invitePhysicalExam: 'Knowledge Gap Assessment',
    inviteSuccessTitle: 'Knowledge Gap Assessment Invitation',
    inviteTransferShort: 'Invite to Transfer',
    ji: 'Intent Level',
    jie: 'Frozen',
    jiuyear: 'Grade 9',
    juniorHigh: 'Middle School',
    kexue: 'Science',
    knowledgePointMasteryRate: 'Knowledge Point Mastery Rate',
    latestTag: 'Latest',
    leadNameLabel: 'Lead Name:',
    leadPhoneLabel: 'Lead Mobile Number:',
    learningCenterAccount: 'Learning Center Account',
    learningCenterAccountColumn: 'Learning Center Account',
    learningMachine: 'Learning Tablet',
    learningMachineAccount: 'Learning Tablet Account',
    learningMachineSn: 'Learning Tablet SN Code',
    li: 'Physics',
    liuyear: 'Grade 6',
    location: 'Location',
    logisticsCompanyName: 'Logistics Company Name',
    logisticsDetailTitle: 'Logistics Details',
    machine: 'Learning Tablet Account',
    markInvalid: 'Mark as Invalid',
    marker25: 'Marked By',
    microFlyer: 'Flyer',
    microVideo: 'Short Video',
    mobileColumn: 'Mobile Number',
    mobileLabel: 'Mobile Number',
    nameLabelColumn: 'Name',
    nameRequired: 'Name is required',
    newPhone: 'New Mobile Number',
    nextCommunicateTime: 'Next Follow-up Time',
    nextStep: 'Next',
    no0: 'No',
    offShelf: 'Unpublish',
    openEntryAccount: 'Activate Starter Account',
    openPhysicalExam: 'Start Experience',
    openTime: 'Activation Time',
    operateTime: 'Operation Time',
    operation: 'Operation',
    operationColumn: 'Operation',
    operationMode20: 'Operation Mode',
    operationMode3: 'Operation Mode',
    operationMode6: 'Operation Mode',
    operationMode9: 'Operation Mode',
    operationSuccess: 'Operation successful',
    operator: 'Operator',
    originalPhone: 'Original Mobile Number',
    ownerTimeLabel: 'Assignment Time',
    passStatusColumn: 'Pass Status',
    passStatusTable: 'Pass Status',
    passportStatusPass: 'Pass Active',
    password: 'Password',
    passwordLabel: 'Password',
    pauseActivityTitle: 'Pause Activity',
    pendingAllocateStatus: 'Pending Assignment',
    pendingFollowStatus: 'Pending Follow-up',
    phone: 'Mobile Number',
    pleaseEnterActivityName: 'Please enter activity name',
    pleaseEnterClassFrequency: 'Please enter class frequency',
    pleaseEnterClassNum: 'Please enter number of sessions',
    pleaseEnterContent: 'Please enter content',
    pleaseEnterCounterManagerName: 'Please enter counter manager name',
    pleaseEnterFullMarks: 'Please enter full score',
    pleaseEnterLapseReason: 'Please enter invalidation reason',
    pleaseEnterRemarkPlaceholder: 'Please enter remark',
    pleaseEnterReportReason: 'Please enter reporting reason',
    pleaseEnterSN: 'Please enter SN code',
    pleaseEnterSNCode: 'Please enter SN code',
    pleaseEnterScore: 'Please enter score',
    pleaseEnterSourceName: 'Please enter source name',
    pleaseEnterTagName: 'Please enter tag name',
    pleaseEnterTagNamePlaceholder: 'Please enter tag name',
    pleaseEnterWeeklyFoundationHours: 'Please enter weekly foundation study hours',
    pleasePerfectUserProfile: 'Please complete user profile first',
    pleaseSelectAppointmentTime: 'Please select appointment time',
    pleaseSelectBirthDate: 'Please select birth date',
    pleaseSelectExamDate: 'Please select exam date',
    pleaseSelectExamType: 'Please select exam type',
    pleaseSelectExperienceAnalyst: 'Please select experience Analyst',
    pleaseSelectFollowType: 'Please select follow-up type',
    pleaseSelectStageGrade: 'Please select stage/grade',
    pleaseSelectStatus: 'Please select status',
    pleaseSelectStudentFirst: 'Please select student',
    pleaseSelectSubTag: 'Please select sub-tag',
    pleaseSelectTag: 'Please select tag',
    preview: 'Preview',
    previewTitle: 'Preview',
    primarySchool: 'Elementary School',
    productName: 'Product Name',
    progressOperator: 'Operator',
    progressScoreRangeAbove40: 'Above 40',
    promisedVisitOption: 'Visit Scheduled',
    promisedVisitStatus: 'Visit Scheduled',
    promoterQuery: 'Promoter Search:',
    prototypeDeviceSNLabel: 'Device SN Code:',
    prototypePleaseEnterDeviceSN: 'Please enter device SN code',
    prototypePleaseSelectType: 'Please select Demo Device type',
    publish: 'Publish',
    publishSuccess: 'Published successfully',
    published: 'Published',
    qiyear: 'Grade 7',
    receiveSuccess: 'Claim successful',
    remarkLabel: 'Remark',
        remarkLabelWithColon: 'Remark:',
    remarkLabelShort: 'Remark',
    reportActiveLocation: 'Reported Activation Location',
    reportAgain: 'Report Again',
    reportBy: 'Reported By',
    reportReason: 'Reporting Reason',
    reportTime: 'Reporting Time',
    resendVerifyCode: 'Resend',
    reviewResult: 'Review Result',
    ruxue: 'Enrollment Score',
    saleName: 'Sales Rep',
    sanyear: 'Grade 3',
    saveSuccess: 'Saved successfully',
    scheduleTimeMustBeFuture: 'Selected time must be later than the current time',
    schoolNameLabel: 'School Name',
    schoolPlaceholder: 'School',
    scoreCaseCardDayUnit: 'days',
    scoreCaseCardTitleScorePoints: '{score} points',
    searchCustomerLabel: 'Search Customer:',
    selectNextFollowTime: 'Select Next Follow-up Time',
    senior1: 'Grade 10',
    senior2: 'Grade 11',
    senior3: 'Grade 12',
    senior4: 'Other',
    seniorHigh: 'High School',
    sheng: 'Biology',
    shu: 'Units Promoted',
    siyear: 'Grade 4',
    snCode: 'SN Code',
    source14: 'Source',
    source19: 'Source',
    source2: 'Source',
    source21: 'Source',
    source23: 'Source',
    source5: 'Source',
    source7: 'Source',
    sourceColumn: 'Source',
    stageGradeColumn: 'Stage / Grade',
    stageGradeLabelShort: 'Stage / Grade',
    stageGradeTable2: 'Stage / Grade',
    startActivityTitle: 'Start Activity',
    status: 'Status',
    subscribed: 'Subscribed',
    systemError: 'System error',
    tag1: 'Tag',
    tag15: 'Tag',
    tag18: 'Tag',
    tag22: 'Tag',
    tag24: 'Tag',
    tag4: 'Tag',
    tag8: 'Tag',
    tagTypeColumn: 'Tag Type',
    taskStatusCancelled: 'Cancelled',
    taskStatusCompleted: 'Completed',
    taskStatusNotStarted: 'Not Started',
    templateListPleaseSelectTemplateType: 'Please select template type',
    templateListTagSelectPlaceholder: 'Tag',
    templateOffShelfSuccess: 'Unpublished successfully',
    testDuration: 'Test Duration',
    testStatus: 'Test Status',
    text0b7p: 'Tag',
    text0rj0: 'All',
    text115o: 'View Report',
    text1dm0: 'Gift Claim Status',
    text2hfg: 'Copy',
    text3k7c: 'Copy',
    text3qx2: 'Subject',
    text5fi2: 'Here',
    text5mof: 'Review Status',
    text5mwq: 'Store Visit Conversion Rate',
    text5uk0: 'Cancel',
    text6sid: 'Mark as Invalid',
    text7tft: 'Intent Level',
    text7tmb: 'Source',
    text7tna: 'Copy',
    text8nto: 'Current Ranking',
    text9bhv: 'Growth Report',
    textaqxc: 'Invite Again',
    textbayd: 'All',
    textbj5w: 'Elementary School',
    textccnj: 'Study Days',
    textczme: 'Mobile',
    textd4oi: 'Save',
    textddaj: 'Here',
    textdo4x: 'Note',
    textdpjq: 'Connection URL',
    texte50z: 'Fetch Form Data',
    textew92: 'Cancel',
    textfdf6: 'Curriculum Version',
    texththy: 'View Report',
    textj6ki: 'Fetch Form Data',
    textlpqu: 'Sessions',
    textm2yt: 'Invitation Progress',
    textn2wh: 'Score Improvement',
    textn7qn: 'File Name',
    textnfjg: 'Confirm',
    textol3p: 'View Report',
    textonft: 'Unsubscribe',
    textpgqw: 'Number of Helpers',
    textq0g4: 'Validity Period',
    textq1x0: 'Review',
    textq7fj: 'Improvement Course Plan',
    texts56p: 'Login',
    texttkth: 'Determines the final API parameter name',
    texttx2k: 'Attachment',
    texttyhq: 'Invite Knowledge Gap Assessment',
    textuj8v: 'Publish',
    textv3l2: 'Download Poster',
    textvfnm: 'Store Visits',
    textvjwj: 'Failed to load',
    textvoqt: 'Search User',
    textw1de: 'Stage',
    textw3pi: 'Confirm',
    textwvyp: 'Login Method',
    textxan7: 'Test Report',
    textxb1x: 'Export',
    textxjvh: 'Sort',
    textxrls: 'Logout',
    textxvbk: 'Invalidation Reason',
    textygf8: 'Subject',
    textyr7v: 'Closed Deals',
    textyrvw: 'Test Confirmation',
    textys3t: 'Subject',
    textys4t: 'Subject',
    textytgg: 'Unsubscribe',
    textzrxs: 'Gender',
    trialStatusConverted: 'Converted',
    trialStatusExpired: 'Expired',
    type: 'Type',
    unit: 'Unit',
    updateBtn: 'Update',
    uploadFail: 'Upload failed',
    userProfileLabelForm: 'User Profile:',
    validityPeriod: 'Validity Period',
    version: 'Version',
    visitStoreLabelShort: 'Visited Store:',
    visitedOption: 'Visited',
    visitedStatus: 'Visited',
    wechatScanPreview: 'Scan with WeChat to preview',
    wuyear: 'Grade 5',
    xue: 'Chemistry',
    xuexiao: 'School',
    yes1: 'Yes',
    yiyear: 'Grade 1',
  }
};
